<template>
    <div class="room-light" :class="{'cn':version == '1'}">
        <div class="room-light_top">
            <div class="box btn" @click="linkToFun('/room')">
                <i class="iconfont icon-back"></i><span class="span1">{{$t('App.room_light.text1')}}</span>
            </div>
            <div class="l"></div>
            <div class="box"><span class="span2">{{$t('App.room_light.text2')}} →</span></div>
            <div class="box">
                    <span class="span1">
                        {{buildName+'#'+roomName}}<i class="el-icon-caret-bottom el-icon--right"></i>
                    </span>
            </div>
        </div>
        <div class="light_img_box light_icon_box" v-if="hasLight == '1'">
            <img :src="require('../img/room/light_'+lightStatus+'.png')">
            <p class="text">{{$t('App.dashboard.text32')}}</p>
        </div>
        <div class="cirLight_img_box light_icon_box" v-if="hasCrcLight == '1'">
            <img :src="require('../img/room/cirLight_'+crcLightStatus+'.png')">
            <p class="text" v-if="domainName != 'plant'">{{$t('App.dashboard.text33')}}</p>
            <p class="text" v-if="domainName == 'plant'">{{$t('App.sideBar.text24')}}</p>
        </div>
        <div class="sensor_img_box light_icon_box"  v-if="hasSensor == '1'">
            <img :src="require('../img/room/sensor_'+sensorStatus+'.png')">
            <p class="text">{{$t('App.room_light.text73')}}</p>
        </div>
        <div class="airPurifiers_img_box light_icon_box"  v-if="hasPurifier == '1'">
            <img :src="require('../img/room/airPurifiers_'+purifierStatus+'.png')">
            <p class="text">{{$t('App.dashboard.text35')}}</p>
        </div>
        <div class="time_box">
            <div class="box time_zone">
                <img src="../img/room/time-zone.png">
                <span class="span1">{{$t('App.room_light.text3')}}</span>
                <span class="span2">{{newTimeData.time_zone}}</span>
            </div>
            <div class="box current_time">
                <img src="../img/room/current-time.png">
                <span class="span1">{{$t('App.room_light.text4')}}</span>
                <span class="span2">{{newTimeData.time}}</span>
            </div>
            <div class="box wake_up_time">
                <img src="../img/room/wake-up-time.png">
                <span class="span1">{{$t('App.room_light.text5')}}</span>
                <span class="span2">{{newTimeData.wakeupTime}}</span>
            </div>
        </div>
        <div class="room-light_left">
            <div class="flex_ul1">
                <div class="flex_li flex_li1" :class="{'select':deviceType === '0'}" @click="deviceTypeFun('0')">
                    <div class="bg1"></div>
                    <div class="bg2"></div>
                    <img :src="img_device_0">
                    <!-- <img :src="deviceType==='0'?require('../img/device_0_2.png'):require('../img/device_0_1.png')"> -->
                    <p>{{$t('App.dashboard.text32')}}</p>
                </div>
                <div class="flex_li flex_li2" :class="{'select':deviceType === '1'}" @click="deviceTypeFun('1')">
                    <div class="bg1"></div>
                    <div class="bg2"></div>
                    <img :src="img_device_1">
                    <p v-if="domainName != 'plant'">{{$t('App.dashboard.text33')}}</p>
                    <p v-if="domainName == 'plant'">{{$t('App.sideBar.text24')}}</p>
                </div>
                <div class="flex_li flex_li3" :class="{'select':deviceType == '2'}" @click="deviceTypeFun('2')">
                    <div class="bg1"></div>
                    <div class="bg2"></div>
                    <img :src="img_device_2">
                    <p>{{$t('App.room_light.text73')}}</p>
                </div>
                <div class="flex_li flex_li3" :class="{'select':deviceType == '3'}" @click="deviceTypeFun('3')">
                    <div class="bg1"></div>
                    <div class="bg2"></div>
                    <img :src="img_device_3">
                    <p>{{$t('App.dashboard.text35')}}</p>
                </div>
            </div>
            <div class="flex_ul2">
                <div class="flex_ul scrollbar_style" v-loading="loading.deviceList">
                    <div class="flex_li_box" :class="{'select':deviceId == '-1'}" :style="{'width': deviceList.length>1?'calc(100% - 3rem)':'calc(50% - 1.5rem)'}">
                        <div class="flex_li" :class="{'select':deviceId == item.id||deviceId == '-1','offline':item.online==0&&deviceType == 3}" @click="deviceSelectFun(item)" v-for="(item) in deviceList" :key="item.id" :style="{'width': deviceList.length>1?'calc(50% - 0.5rem)':'calc(100% - 0.5rem)'}">
                            <div class="img_box">
                                <div class="bg">
                                    <!-- <img src="../img/login_bg.jpg"> -->
                                    <!-- <img :src="item.image"> -->
                                    <span class="pl_switch" :class="{'checked':item.status > 0}" @click="plSwitBrightnesschFun(item,item.id)" v-loading="item.loading_0" v-if="deviceType == '0'||deviceType == '1'"></span>
                                </div>
                            </div>
                            <p class="name">{{item.name}}</p>
                            <div class="spot" v-if="deviceType == 3" :class="{'select':item.screen_status}"></div>
                            <div class="status" :class="{'online':item.online==1}" :style="{'bottom':'7.5rem'}" v-if="item.online!=1">{{item.online==1?'Online':'Offline'}}</div>
                        </div>
                    </div>
                </div>
                <div class="btn" :class="{'select':deviceId == '-1'}" @click="deviceSelectFun({id:'-1'})">All</div>
            </div>
        </div>
        <div class="room-light_right">
            <div class="right_box1">
                <div class="right_box1_top">
                    <div class="box1" :class="{'select':deviceInfoType == '1'}" @click="deviceInfoTypeFun('1')">
                        <div class="bg"></div>
                        <div class="text" v-if="deviceId != '-1'">{{deviceInfoTypeTitle1}}</div>
                        <div class="text" v-if="deviceId == '-1'">{{$t('App.room_light.text6')}}</div>
                    </div>
                    <div class="box2" :class="{'select':deviceInfoType == '2'}" @click="deviceInfoTypeFun('2')"  v-if="deviceId != '-1'&&deviceId">
                        <div class="bg"></div>
                        <div class="text">{{deviceInfoTypeTitle2}}</div>
                    </div>
                </div>
                <div class="wrap1" v-if="deviceInfoType == '1'" key="deviceInfoType_w1">
                    <div class="echarts_box" v-if="(deviceType == '0'||deviceType == '1'||deviceType == '3')&&deviceId">
                        <!-- <div class="top" v-if="deviceType == '3'">
                            <div class="div1">
                                <div class="div1_l">
                                    <span>83</span>
                                </div>
                                <div class="div1_r">
                                    <p class="p1">Good</p>
                                    <p class="p2">Average air quality</p>
                                </div>
                            </div>
                            <div class="div2"></div>
                        </div> -->
                        <div class="echarts_top" :style="{'padding':deviceType == '3'?'1.3rem 0.45rem':'0.67rem 0.92rem 1rem'}">
                            <span v-if="deviceType!='3'">{{$t('App.room_light.text7')}}</span>
                            <span v-if="deviceType=='3'">{{$t('App.room_light.text8')}}</span>
                            <el-dropdown @command="timeTypeCommand1" trigger="click" @visible-change="commandHide('dropdown_room_light_timeType')" v-if="deviceType == '0'">
                                <span class="el-dropdown-link">
                                    {{timeTypeStr1}}<i class="el-icon-caret-bottom el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_room_light_timeType">
                                    <el-dropdown-item v-for="item in timeTypeArr" :command="item" :key="item.value" :class="{'select':timeType1==item.value}">{{item.label}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <el-dropdown @command="timeTypeCommand2" trigger="click" @visible-change="commandHide('dropdown_room_light_timeType')" v-if="deviceType == '1'">
                                <span class="el-dropdown-link">
                                    {{timeTypeStr2}}<i class="el-icon-caret-bottom el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_room_light_timeType">
                                    <el-dropdown-item v-for="item in timeTypeArr" :command="item" :key="item.value" :class="{'select':timeType2==item.value}">{{item.label}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <el-dropdown @command="timeTypeCommand4" trigger="click" @visible-change="commandHide('dropdown_room_light_timeType')" v-if="deviceType == '3'">
                                <span class="el-dropdown-link">
                                    {{timeTypeStr4}}<i class="el-icon-caret-bottom el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_room_light_timeType">
                                    <el-dropdown-item v-for="item in timeTypeArr" :command="item" :key="item.value" :class="{'select':timeType4==item.value}">{{item.label}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div class="electricity_consumption_echarts" v-if="deviceType == '0'||deviceType == '1'" key="electricity_consumption_echarts1" :style="{height:lampCmdData.alarmStatus=='1'?'8.5rem':''}"></div>

                        <!-- <div class="electricity_consumption_echarts" v-if="deviceType == '2'" key="electricity_consumption_echarts2" :style="{height:sensorInfoData.alarmStatus=='0'&&sensorInfoData.online=='1'?'12.2rem':''}"></div> -->
                        <div class="electricity_consumption_echarts deviceType3" v-if="deviceType == '3'" key="electricity_consumption_echarts2" :style="{height:purifierInfoData.alarmStatus=='1'?'9.5rem':''}"></div>
                    </div>
                    <div class="wrap1_top_2" v-if="deviceType == '2'&&deviceId">
                        <p class="title"><span>{{$t('App.room_light.text9')}}</span> <i @click="updateSensorInfo()" v-loading="loading.updateSensorInfo" class="el-icon-refresh"></i></p>
                        <div class="box1">
                            <p class="p1">{{$t('App.room_light.text10')}}</p>
                            <p class="p2">{{sensorInfoData.useTime}}h</p>
                            <div class="img_box">
                                <img :src="img_sensor_icon">
                            </div>
                        </div>
                        <div class="flex_ul">
                            <div class="flex_li">
                                <p class="p1">{{$t('App.dashboard.text11')}}</p>
                                <p class="p2">{{sensorInfoData.temperature}}℃</p>
                            </div>
                            <div class="flex_li">
                                <p class="p1">{{$t('App.dashboard.text12')}}</p>
                                <p class="p2">{{sensorInfoData.humidity}}RH%</p>
                            </div>
                            <div class="flex_li">
                                <p class="p1">CO₂</p>
                                <p class="p2">{{sensorInfoData.co2}}ppm</p>
                            </div>
                            <div class="flex_li">
                                <p class="p1">PM2.5</p>
                                <p class="p2">{{sensorInfoData.pm25}}µg/m³</p>
                            </div>
                            <div class="flex_li">
                                <p class="p1">PM10</p>
                                <p class="p2" v-if="sensorInfoData.pm10!=0">{{sensorInfoData.pm10}}µg/m³</p>
                                <p class="p2" v-if="sensorInfoData.pm10==0">-</p>
                            </div>
                            <div class="flex_li">
                                <p class="p1">TVOC</p>
                                <p class="p2">{{sensorInfoData.voc}}ppb</p>
                            </div>
                            <div class="flex_li">
                                <p class="p1">{{$t('App.dashboard.text13')}}</p>
                                <p class="p2">{{sensorInfoData.formaldehyde}}ppb</p>
                            </div>
                            <!-- <div class="flex_li">
                                <p class="p1">pressure</p>
                                <p class="p2">{{sensorInfoData.temperature}}Pa</p>
                            </div> -->
                        </div>
                    </div>
                    <div class="bottom" v-if="(deviceType == '0'||deviceType == '1')&&deviceId && (lampCmdData.alarmStatus =='1')" @click="linkToFun('/service')">
                        <div class="img_box">
                            <img src="../img/svg/warn_icon.svg"><span>{{$t('App.room_light.text11')}}</span>
                        </div>
                        <div class="text_box">
                            <span>{{$t('App.room_light.text12')}}</span>
                        </div>
                    </div>
                    <div class="bottom" v-if="deviceType == '2'&&deviceId && (sensorInfoData.alarmStatus=='1')"  @click="linkToFun('/service')">
                        <div class="img_box">
                            <img src="../img/svg/warn_icon.svg"><span>{{$t('App.room_light.text13_1')}}</span>
                        </div>
                        <div class="text_box">
                            <span>{{$t('App.room_light.text12')}}</span>
                        </div>
                    </div>
                    <div class="bottom" v-if="(deviceType == '3'&&deviceId)&& (purifierInfoData.alarmStatus =='1')">
                        <div class="img_box">
                            <img src="../img/svg/warn_icon.svg"><span>{{$t('App.room_light.text13')}}</span>
                        </div>
                        <div class="text_box">
                            <span>{{$t('App.room_light.text12')}}</span>
                        </div>
                    </div>
                </div>
                <div class="wrap2" v-if="deviceInfoType == '2'" key="deviceInfoType_w2">
                    <div class="img_box">
                        <img :src="require('../img/device-Information_'+deviceType+(version=='1'?'_v1':'')+'.png')">
                    </div>
                    <div class="div">
                        <span class="span1">{{$t('App.room_light.text14')}}</span>
                        <span class="span2" v-if="deviceType == '0' || deviceType == '1'">{{lampCmdData.name}}</span>
                        <span class="span2" v-if="deviceType == '2'">{{sensorInfoData.name}}</span>
                        <span class="span2" v-if="deviceType == '3'">{{purifierInfoData.name}}</span>
                    </div>
                    <div class="div">
                        <span class="span1">{{$t('App.room_light.text15')}}</span>
                        <span class="span2" v-if="deviceType == '0' || deviceType == '1'" :title="lampCmdData.deviceId">{{lampCmdData.deviceId}}</span>
                        <span class="span2" v-if="deviceType == '2'" :title="sensorInfoData.deviceId">{{sensorInfoData.deviceId}}</span>
                        <span class="span2" v-if="deviceType == '3'" :title="purifierInfoData.deviceId">{{purifierInfoData.deviceId}}</span>
                    </div>
                    <!-- <div class="div" v-if="deviceType == '1'">
                        <span class="span1">{{$t('App.room_light.text16')}}</span>
                        <el-dropdown @command="cirLightsPlanCommand" trigger="click" @visible-change="commandHide('dropdown_circadianLights_plan')">
                            <span class="el-dropdown-link" :title="cirLightsPlanName">
                                <span>{{cirLightsPlanName}}</span><i class="el-icon-caret-bottom el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_circadianLights_plan">
                                <el-dropdown-item v-for="item in cirLightsPlanList" :command="item" :key="item.id" :class="{'select':cirLightsPlanId==item.id}">{{item.cvsname}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div> -->
                    <div class="btn_box">
                        <div class="btn" @click="editFun(deviceType)">{{$t('App.room_light.text17')}}</div>
                        <div class="l"></div>
                        <div class="btn" @click="historySee()">{{$t('App.room_light.text18')}}</div>
                    </div>
                </div>
            </div>
            <div class="right_box2" v-if="deviceInfoType == '1' && (deviceType == '0' || deviceType == '1')">
                <div class="scrollbar_style" v-if="deviceId">
                    <p class="p1">
                        <span v-if="deviceType == '0'">{{$t('App.room_light.text19')}}</span>
                        <span v-if="deviceType == '1'&&domainName != 'plant'">{{$t('App.room_light.text20')}}</span>
                        <span v-if="deviceType == '1'&&domainName == 'plant'">{{$t('App.room_light.text20_')}}</span>
                        
                        <span class="pl_switch" v-if="deviceType == '0'" :class="{'checked':lampCmdData.status == 1}" @click="plSwitBrightnesschFun(lampCmdData,lightId,'all')" v-loading="lampCmdData.loading_0"></span>
                        <span class="pl_switch" v-if="deviceType == '1'&& deviceId != '-1'" :class="{'checked':roomLightBoottomNavVal2}" @click="roomLightBoottomNavFun(2)" v-loading="loading.roomLightBoottomNavFun"></span>
                    </p>
                    <template v-if="deviceType == '0'">
                        <div class="RGBW_box" v-if="lampCmdData.model=='75'||lampCmdData.model=='85'" v-loading="loading.lightStyleFun">
                            <div class="btn" :class="{'select':lampCmdData.style == '1'}" @click="lightStyleFun('1')">{{$t('App.room_light.text21')}}</div>
                            <div class="btn" :class="{'select':lampCmdData.style == '2'}" @click="lightStyleFun('2')">{{$t('App.room_light.text22')}}</div>
                            <div class="btn" :class="{'select':lampCmdData.style == '3'}" @click="lightStyleFun('3')">{{$t('App.room_light.text23')}}</div>
                        </div>
                        <p class="p2 p21">{{$t('App.room_light.text24')}}</p>
                        <p class="p3">
                            <span class="text" :class="{'loading':lampCmdData.loading_0}">{{lampCmdData.light}}%</span>
                            <el-input-number :class="{'input_loading':lampCmdData.loading_0}" v-model="lampCmdDataLight" :min="0" :max="100" :controls="false" @blur="postLampLight('1',lightId,deviceId == '-1'?'all':null,lampCmdData)"></el-input-number>
                        </p>
                        
                        <el-slider v-model="lampCmdDataLight" @change="postLampLight('1',lightId,deviceId == '-1'?'all':null,lampCmdData)" :step="1" :min="0" :max="100" class="slider1" v-loading="lampCmdData.loading_0"></el-slider>
                        <p class="p2 p22" v-if="lampCmdData.model!='0'&&lampCmdData.model!='75'&&lampCmdData.model!='85'">{{$t('App.room_light.text25')}}</p>
                        <p class="p3" v-if="lampCmdData.model!='0'&&lampCmdData.model!='75'&&lampCmdData.model!='85'">{{lampCmdData.color}}K</p>
                    </template>
                    <template v-if="deviceType == '0'&&lampCmdData.model!='0'">
                        <el-slider v-model="lampCmdDataColor" @change="postLampColor('1')" :step="300" :min="3000" :max="6000" class="slider2" v-loading="loading.lampColor" v-if="lampCmdData.model!='75'&&lampCmdData.model!='85'"></el-slider>
                        <p class="p2 p23" v-if="lampCmdData.model =='2'||lampCmdData.model =='3'||lampCmdData.model =='6'||lampCmdData.model=='75'||lampCmdData.model=='85'">Color picking</p>
                        <color-picker :colorValueChange="colorValueChange" :colorChange="colorChange" ref="colorPicker" v-loading="loading.lampColorRgb" v-if="lampCmdData.model =='2'||lampCmdData.model =='3'||lampCmdData.model =='6'||lampCmdData.model=='75'||lampCmdData.model=='85'"></color-picker>
                    </template>
                    <template v-if="deviceType == '0'&&(lampCmdData.model =='0'||lampCmdData.model =='1')">
                        <div class="img_box">
                            <img :src="require('../img/room/brightness_'+(lampCmdDataLight>0?1:0)+'.png')">
                        </div>
                    </template>
                    <template v-if="deviceType == '1'">
                        <div class="dataColor_1_box_box" v-if="deviceId != '-1'">
                            <div class="cirdadian_slider">
                                <div class="hotel_forecast" @click="getHotelForecast(lampCmdData.hotelId)" v-loading="loading.getHotelForecast">
                                    <img src="../img/room/circadian_0.png" v-if="!roomLightBoottomNavVal2">
                                    <img src="../img/room/circadian_1.png" v-if="roomLightBoottomNavVal2">
                                </div>
                                <el-slider v-model="lampCmdDataColor" :step="100" :min="1200" :max="6500" :class="{'slider_0':!roomLightBoottomNavVal2,'slider_2':roomLightBoottomNavVal2}" v-loading="loading.lampColor" disabled></el-slider>
                            </div>
                            <div class="sunrise_sunset">
                                <div class="sunrise">
                                    <p class="span span3">{{$t('App.room_light.text26')}}</p>
                                    <div class="input_box">
                                        <el-input class="time1" v-model="dataColorTime1" @change="dataColorTimeChange('1')" @input="dataColorTimeInput('1')" type="number" min="0" max="23" disabled></el-input>
                                        <span>:</span>
                                        <el-input class="time2" v-model="dataColorTime2" @change="dataColorTimeChange('2')" @input="dataColorTimeInput('2')" type="number" min="0" max="59" disabled></el-input>
                                    </div>
                                    <p class="span span3">{{$t('App.room_light.text27')}}</p>
                                    <div class="input_box">
                                        <el-input class="time1" v-model="bottomDemoTime1_" @change="dataColorTimeChange('1')" @input="dataColorTimeInput('1')" type="number" min="0" max="23" disabled></el-input>
                                        <span>:</span>
                                        <el-input class="time2" v-model="bottomDemoTime2_" @change="dataColorTimeChange('2')" @input="dataColorTimeInput('2')" type="number" min="0" max="59" disabled></el-input>
                                    </div>
                                </div>
                                <div class="gauge_box">
                                    <div class="gauge" :class="{'gauge_1':roomLightBoottomNavVal2}">
                                        <p class="text text1">{{$t('App.room_light.text28')}}</p>
                                        <p class="text text2">{{$t('App.room_light.text29')}}</p>
                                        <div class="after" :style="{'transform': 'rotate('+(lampCmdDataColor-3850)/265*9+'deg)'}"></div>
                                    </div>
                                    <div class="input_box">
                                        <el-input class="color_input" v-model="dataColorInput0" type="number" min="0" max="9" disabled></el-input>
                                        <el-input class="color_input" v-model="dataColorInput1" type="number" min="0" max="9" disabled></el-input>
                                        <el-input class="color_input" v-model="dataColorInput2" type="number" min="0" max="9" disabled></el-input>
                                        <el-input class="color_input" v-model="dataColorInput3" type="number" min="0" max="9" disabled></el-input>
                                        <span class="span_input">K</span>
                                    </div>
                                </div>
                                <div class="sunset">
                                    <p class="span span4">{{$t('App.room_light.text30')}}</p>
                                    <div class="input_box">
                                        <el-input class="time3" v-model="dataColorTime3" @change="dataColorTimeChange('3')" @input="dataColorTimeInput('3')" type="number" min="0" max="23" disabled></el-input>
                                        <span>:</span>
                                        <el-input class="time4" v-model="dataColorTime4" @change="dataColorTimeChange('4')" @input="dataColorTimeInput('4')" type="number" min="0" max="59" disabled></el-input>
                                    </div>
                                    <p class="span span4">{{$t('App.room_light.text31')}}</p>
                                    <div class="input_box">
                                        <el-input class="time3" v-model="bottomDemoTime3_" @change="dataColorTimeChange('3')" @input="dataColorTimeInput('3')" type="number" min="0" max="23" disabled></el-input>
                                        <span>:</span>
                                        <el-input class="time4" v-model="bottomDemoTime4_" @change="dataColorTimeChange('4')" @input="dataColorTimeInput('4')" type="number" min="0" max="59" disabled></el-input>
                                    </div>
                                </div>
                            </div>
                            <div class="brightness">
                                <div class="title">{{$t('App.room_light.text33')}}</div>
                                <div class="flex">
                                    <div class="input_box">
                                        <el-input class="color_input" v-model="databrightnessInput0" type="number" min="0" max="9" disabled></el-input>
                                        <el-input class="color_input" v-model="databrightnessInput1" type="number" min="0" max="9" disabled></el-input>
                                        <el-input class="color_input" v-model="databrightnessInput2" type="number" min="0" max="9" disabled></el-input>
                                        <span class="span_input">%</span>
                                    </div>
                                    <div class="dataColor_1_box">
                                        <div class="btn btn1" @click="lampCmdDataLightChange('-')"><i class="el-icon-minus"></i></div>
                                        <el-slider v-model="lampCmdDataLight"  @change="postLampLight('2',lightId,deviceId == '-1'?'all':null,lampCmdData)" :step="1" :min="0" :max="100" class="slider1" v-loading="lampCmdData.loading_0"></el-slider>
                                        <div class="btn bnt2" @click="lampCmdDataLightChange('+')"><i class="el-icon-plus"></i></div>
                                    </div>
                                </div>
                            </div>
                            <p class="p1">
                                <span>{{$t('App.room_light.text32')}}</span>
                                <span class="pl_switch" :class="{'checked':cirdadianLights}" @click="cirdadianLightsFun()"></span>
                            </p>
                            <div class="manual_control" :class="{'activated':!cirdadianLights}">
                                <div class="colorTemp">
                                    <div  class="title">{{$t('App.room_light.text34')}}</div>
                                    <div class="flex">
                                        <div class="input_box">
                                            <el-input class="color_input" v-model="dataColorTempInput0" type="number" min="0" max="9" disabled></el-input>
                                            <el-input class="color_input" v-model="dataColorTempInput1" type="number" min="0" max="9" disabled></el-input>
                                            <el-input class="color_input" v-model="dataColorTempInput2" type="number" min="0" max="9" disabled></el-input>
                                            <el-input class="color_input" v-model="dataColorTempInput3" type="number" min="0" max="9" disabled></el-input>
                                            <span class="span_input">K</span>
                                        </div>
                                        <div class="dataColor_1_box">
                                            <div class="btn btn1" @click="lampCmdDataColorChange('-')"><i class="el-icon-minus"></i></div>
                                            <el-slider v-model="lampCmdDataColor_circadian" @change="postLampColor('2')"  :disabled="!cirdadianLights" :step="1" :min="0" :max="14" class="slider2" v-loading="loading.lampColor" :format-tooltip="formatTooltip"></el-slider>
                                            <div class="btn bnt2" @click="lampCmdDataColorChange('+')"><i class="el-icon-plus"></i></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <p class="p1">
                                <span>{{$t('App.room_light.text35')}}</span>
                                <span class="btn" @click="lightTest()" :class="{'run':lightTestIndex>0}" v-loading="loading.run">{{$t('App.room_light.text39')}}</span>
                            </p>
                            <div class="simulation_test">
                                <div class="simulation" :class="{'run':lightTestIndex>0}"><div class="line" v-if="lightTestIndex>0" :style="{'left':lightTestIndex*3.33+'%'}"></div></div>
                                <p class="test_box"><span class="test1">{{$t('App.room_light.text37')}}</span><span class="test1">{{$t('App.room_light.text38')}}</span></p>
                            </div>
                            <div class="bottom_box">
                                <div class="input_box">
                                    <span class="title">{{$t('App.room_light.text36')}}</span>
                                    <div class="flex">
                                        <el-input class="color_input" v-model="runTime0" type="number" min="0" max="9" disabled></el-input>
                                        <el-input class="color_input" v-model="runTime1" type="number" min="0" max="9" disabled></el-input>
                                        <span>:</span>
                                        <el-input class="color_input" v-model="runTime2" type="number" min="0" max="9" disabled></el-input>
                                        <el-input class="color_input" v-model="runTime3" type="number" min="0" max="9" disabled></el-input>
                                        <span class="span_input">{{runTime4}}</span>
                                        
                                    </div>
                                </div>
                                <div class="input_box">
                                    <span class="title">{{$t('App.room_light.text34')}}</span>
                                    <div class="flex">
                                        <el-input class="color_input" v-model="runColor0" type="number" min="0" max="9" disabled></el-input>
                                        <el-input class="color_input" v-model="runColor1" type="number" min="0" max="9" disabled></el-input>
                                        <el-input class="color_input" v-model="runColor2" type="number" min="0" max="9" disabled></el-input>
                                        <el-input class="color_input" v-model="runColor3" type="number" min="0" max="9" disabled></el-input>
                                        <span class="span_input">K</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="dataColor_1_box_box" v-if="deviceId == '-1'">
                            <p class="p2 p21">{{$t('App.room_light.text24')}}</p>
                            <p class="p3">
                                <span class="">{{lampGuangBoHLCLight}}%</span>
                            </p>
                            <el-slider v-model="lampGuangBoHLCLight" :step="1" :min="0" :max="100" class="slider1"></el-slider>
                            <p class="p2 p22">{{$t('App.room_light.text25')}}</p>
                            <p class="p3">
                                <span class="">{{circadianColorArr[lampGuangBoHLCColor]}}</span>
                            </p>
                            <el-slider v-model="lampGuangBoHLCColor" :step="1" :min="0" :max="14" class="slider2"  :format-tooltip="formatTooltip"></el-slider>
                            <div class="btn_box">
                                <div class="btn" @click="guangbo_dimSave()" v-loading="loading.guangbo_dim">{{$t('App.room.text35')}}</div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="right_box2_2" v-if="deviceInfoType == '1' && deviceType == '2'" :style="{height:sensorInfoData.alarmStatus=='1'||sensorInfoData.online =='0'?'calc(100% - 33rem)':''}">
                <template v-if="deviceId">
                    <p class="p1">{{$t('App.room_light.text40')}}</p>
                    <div class="scrollbar_style">
                        <div class="li li1">
                            <div class="li_l">
                                <span>{{$t('App.room_light.text41')}}</span>
                            </div>
                            <div class="li_r">
                                <span class="bg" v-if="sensorInfoData.batteryLevel!=0">
                                    <span class="bg_val_box">
                                        <span class="bg_val" :style="{'width':'calc('+sensorInfoData.batteryLevel+'% - 0.2rem)'}"></span>
                                    </span>
                                </span>
                                <span v-if="sensorInfoData.batteryLevel!=0">{{sensorInfoData.batteryLevel}}%</span>
                                <span v-if="sensorInfoData.batteryLevel==0" style="color: #657085">{{$t('App.room_light.text71')}}</span>
                            </div>
                        </div>
                        <div class="li li2">
                            <div class="li_l">
                                <span>{{$t('App.room_light.text42')}}</span>
                            </div>
                            <div class="li_r">
                                <span>{{batteryStatusArr[sensorInfoData.batteryStatus]}}</span>
                            </div>
                        </div>
                        <div class="li li3">
                            <div class="li_l">
                                <span>{{$t('App.room_light.text43')}}</span>
                            </div>
                            <div class="li_r">
                                <span>{{onlineArr[sensorInfoData.online]}}</span>
                            </div>
                        </div>
                        <div class="li li4">
                            <div class="li_l">
                                <span>{{$t('App.room_light.text72')}}</span>
                            </div>
                            <div class="li_r">
                                <span class="pl_switch" :class="{'checked':sensorInfoData.status == '1'}" @click="sensorSet_status()" v-loading="loading.sensorSet_status">{{sensorStatusArr[sensorInfoData.status]}}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="right_box2_3" v-if="deviceInfoType == '1' && deviceType == '3'">
                <template v-if="deviceId">
                    <p class="p1">{{$t('App.room_light.text45')}}</p>
                    <div class="scrollbar_style">
                        <div class="li li1">
                            <div class="li_l">
                                <span>{{$t('App.room_light.text46')}}</span>
                                <span class="pl_switch" :class="{'checked':purifierInfoData.status == 1}" @click="plSwitchPurifierFun(purifierInfoData,'all')" v-loading="trunOffDeviceLoading"></span>
                            </div>
                            <div class="li_r">
                                <el-dropdown @command="levelCommand" trigger="click" @visible-change="commandHide('dropdown_room_light_level')" v-loading="trunOffDeviceLoading">
                                    <span class="el-dropdown-link">
                                        {{levelArr[purifierInfoData.level-1]}}
                                        <i class="el-icon-caret-bottom el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_room_light_level">
                                        <el-dropdown-item v-for="(str,index) in levelArr" :key="str" :command="[index+1,{id:purifierId,data:purifierInfoData},'all']" :class="{'select':purifierInfoData.level==index+1}">{{str}}</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <span class="disabled" v-if="purifierInfoData.status == '0'"></span>
                            </div>
                        </div>
                        <div class="li li2">
                            <div class="li_l">
                                <span>{{$t('App.room_light.text47')}}</span>
                            </div>
                            <div class="li_r">
                                <span>{{onlineArr[purifierInfoData.online]}}</span>
                            </div>
                        </div>
                       <!-- <div class="li li3">
                            <div class="li_l">
                                <span>Wireless strength</span>
                            </div>
                            <div class="li_r">
                                <span>{{purifierInfoData.wifiLevel}}</span>
                            </div>
                        </div> -->
                        <div class="li li4">
                            <div class="li_l">
                                <span>{{$t('App.airPurifiers.text2')}}</span>
                            </div>
                            <div class="li_r">
                                <span>{{purifierInfoData.useTime}}h</span>
                            </div>
                        </div>
                        <div class="li li5">
                            <div class="li_l">
                                <span>{{$t('App.room_light.text49')}}</span>
                            </div>
                            <div class="li_r">
                                <span>{{purifierInfoData.workTime}}h</span>
                            </div>
                        </div>
                       <div class="li li6">
                            <div class="li_l">
                                <span>{{$t('App.airPurifiers.text19')}}</span>
                            </div>
                            <div class="li_r">
                                <el-dropdown @command="commandPurifierSetting" trigger="click" @visible-change="commandHide('dropdown_air_floor')" v-loading="loading.commandPurifierSetting">
                                    <span>
                                        <span class="span1" :title="purifierSettingFormPurModel">{{purifierSettingFormPurModel}}</span>
                                        <i class="el-icon-caret-bottom el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_air_floor">
                                        <el-dropdown-item v-for="item in purModelArr" :command="item" :key="'floor'+item.id" :class="{'select':item.id==purifierFormNew.purModel}">{{item.name}}</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div class="room-light_bottom">
            <div class="room-light_bottom_flex">
                <div class="li" :class="{'select':roomLightBoottomNavVal1}" @click="roomLightBoottomNavFun(1)" v-loading="loading.roomLightBoottomNavFun">
                    <span class="span1">{{$t('App.room_light.text50')}}</span>
                    <span class="pl_switch" :class="{'checked':roomLightBoottomNavVal1}">{{roomLightBoottomNavVal1?'on':'off'}}</span>
                </div>
                <div class="li" :class="{'select':roomLightBoottomNavVal1&&roomLightBoottomNavVal2}"  @click="roomLightBoottomNavFun(2)" v-loading="loading.roomLightBoottomNavFun">
                    <span class="span1" v-if="domainName != 'plant'">{{$t('App.room_light.text51')}}</span>
                    <span class="span1" v-if="domainName == 'plant'">{{$t('App.sideBar.text24')}}</span>
                    <span class="pl_switch" :class="{'checked':roomLightBoottomNavVal1&&roomLightBoottomNavVal2}">{{roomLightBoottomNavVal1&&roomLightBoottomNavVal2?'on':'off'}}</span>
                </div>
                <div class="li" :class="{'select':roomLightBoottomNavVal1&&roomLightBoottomNavVal3}" @click="roomLightBoottomNavFun(3)" v-loading="loading.roomLightBoottomNavFun">
                    <span class="span1">{{$t('App.room_light.text52')}}</span>
                    <span class="pl_switch" :class="{'checked':roomLightBoottomNavVal1&&roomLightBoottomNavVal3}">{{roomLightBoottomNavVal1&&roomLightBoottomNavVal3?'on':'off'}}</span>
                </div>
                <div class="li" :class="{'select':roomLightBoottomNavVal1&&roomLightBoottomNavVal4}" @click="roomLightBoottomNavFun(4)" v-loading="loading.roomLightBoottomNavFun">
                    <span class="span1">{{$t('App.room_light.text53')}}</span>
                    <span class="pl_switch" :class="{'checked':roomLightBoottomNavVal1&&roomLightBoottomNavVal4}">{{roomLightBoottomNavVal1&&roomLightBoottomNavVal4?'on':'off'}}</span>
                </div>
                <div class="li" :class="{'select':roomLightBoottomNavVal5}">
                    <div class="flex"  @click="roomLightBoottomNavFun(5)" v-loading="loading.roomLightBoottomNavFun">
                        <span class="span1">{{$t('App.room_light.text54')}}</span>
                        <span class="pl_switch" :class="{'checked':roomLightBoottomNavVal5}">{{roomLightBoottomNavVal5?'on':'off'}}</span>
                    </div>
                    <div class="li_box" v-show="roomLightBoottomNavVal5">
                        <div class="wake_up_time">
                            <div class="test">{{$t('App.room_light.text55')}}</div>
                            <div class="time_warp">
                                <div class="time1_box scrollbar_style" @mouseleave="timeMouseleave1">
                                    <div class="time1" :class="{'active':bottomDemoTime1==item}" v-for="item in timeArr1" :key="item" @click="bottomDemoTime1Fun(Number(item))">{{item}}</div>
                                </div>
                                <div class="jg">
                                    <div></div>
                                    <div>:</div>
                                    <div></div>
                                </div>
                                <div class="time2_box scrollbar_style"  @mouseleave="timeMouseleave2">
                                    <div class="time2" :class="{'active':bottomDemoTime2==item}" v-for="item in timeArr2" :key="item" @click="bottomDemoTime2Fun(Number(item))">{{item}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="bed_time">
                            <div class="test">{{$t('App.room_light.text56')}}</div>
                            <div class="time_warp">
                                <div class="time1_box scrollbar_style" @mouseleave="timeMouseleave1_">
                                    <div class="time1" :class="{'active':bottomDemoTime3==item}" v-for="item in timeArr1" :key="item" @click="bottomDemoTime1_Fun(Number(item))">{{item}}</div>
                                </div>
                                <div class="jg">
                                    <div></div>
                                    <div>:</div>
                                    <div></div>
                                </div>
                                <div class="time2_box scrollbar_style"  @mouseleave="timeMouseleave2_">
                                    <div class="time2" :class="{'active':bottomDemoTime4==item}" v-for="item in timeArr2" :key="item" @click="bottomDemoTime2_Fun(Number(item))">{{item}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--  -->
        <div class="history_warp scrollbar_style" v-show="historyShowbg">
            <div class="history_warp_bg" @click="historyClose()"></div>
            <div class="history_box" :class="{'history_show':historyShow}">
                <div class="history_top">
                    <span class="span1">{{$t('App.room_light.text18')}}</span>
                    <span class="span2" @click="historyClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="filter_box">
                    <el-select v-model="chartType" placeholder=" " @change="chartTypeChange(chartType)">
                        <el-option
                          v-for="item in chartTypeArr"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                    </el-select>
                    <el-select v-model="timeType3" placeholder=" " @change="timeType2Change(timeType3)">
                        <el-option
                          v-for="item in timeTypeArr"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="echarts_warp scrollbar_style">
                    <div class="echarts_box echarts_box1">
                        <div class="echarts_top">{{echartsName1}}</div>
                        <div class="history_echarts_box1"></div>
                    </div>
                    <div class="echarts_box echarts_box2">
                        <div class="echarts_top">{{echartsName2}}</div>
                        <div class="history_echarts_box2"></div>
                    </div>
                    <template v-if="deviceType == '2'">
                        <div class="echarts_box echarts_box3">
                            <div class="echarts_top">{{echartsName3}}</div>
                            <div class="history_echarts_box3"></div>
                        </div>
                        <div class="echarts_box echarts_box4">
                            <div class="echarts_top">{{echartsName4}}</div>
                            <div class="history_echarts_box4"></div>
                        </div>
                        <div class="echarts_box echarts_boxecharts_box5">
                            <div class="echarts_top">{{echartsName5}}</div>
                            <div class="history_echarts_box5"></div>
                        </div>
                        <div class="echarts_box echarts_boxecharts_box6">
                            <div class="echarts_top">{{echartsName6}}</div>
                            <div class="history_echarts_box6"></div>
                        </div>
                        <div class="echarts_box echarts_box7">
                            <div class="echarts_top">{{echartsName7}}</div>
                            <div class="history_echarts_box7"></div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="lights_wrap scrollbar_style" v-show="lightsTkShowbg">
            <div class="lights_wrap_bg" @click="lightsTkClose()"></div>
            <div class="lights_box" :class="{'lights_tk_show':lightsTkShow}">
                <div class="lights_title">
                    <span class="span1">{{lightTkTitle}}</span>
                    <span class="span2" @click="lightsTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="form">
                    <div class="form_item">
                        <span class="laber">{{$t('App.room_light.text14')}}</span>
                        <el-input v-model="lightsForm.name" placeholder="Please enter device name"></el-input>
                    </div>
                    <div class="form_item" v-if="deviceType == '0'">
                        <span class="laber">{{$t('App.room_light.text57')}}</span>
                        <el-dropdown @command="commandModel" trigger="click" @visible-change="commandHide('dropdown_lights_model')">
                            <span class="span1">{{lightsFormModelName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_lights_model">
                                <el-dropdown-item v-for="item in modelNavLight" :command="item" :key="'floor'+item.id" :class="{'select':item.id==lightsForm.model}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item" v-if="deviceType == '1'">
                        <span class="laber">{{$t('App.room_light.text57')}}</span>
                        <el-dropdown @command="commandModel" trigger="click" @visible-change="commandHide('dropdown_lights_model')">
                            <span class="span1">{{cirLightsFormModelName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_lights_model">
                                <el-dropdown-item v-for="item in modelNavCirLight" :command="item" :key="'floor'+item.id" :class="{'select':item.id==lightsForm.model}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text18')}}</span>
                        <el-input v-model="lightsForm.deviceId" placeholder="Please enter device id"></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text22')}}</span>
                        <el-dropdown @command="commandFloorLights" trigger="click" @visible-change="commandHide('dropdown_lights_floor')">
                            <span class="span1">{{lightsFormFloorName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_lights_floor">
                                <el-dropdown-item v-for="item in floorNav" :command="item" :key="'floor'+item.id" :class="{'select':item.id==lightsForm.floorId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text23')}}</span>
                        <el-dropdown @command="commandRoomLights" trigger="click" @visible-change="commandHide('dropdown_lights_room')">
                            <span class="span1">{{lightsFormRoomName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_lights_room">
                                <el-dropdown-item v-for="item in roomNav" :command="item" :key="'room'+item.id" :class="{'select':item.id==lightsForm.roomId}">{{item.number}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="postSaveLight(deviceType)">{{$t('App.room.text35')}}</div>
                </div>
            </div>
        </div>
        <!-- sensor -->
        <div class="sensor_wrap scrollbar_style" v-show="sensorTkShowbg">
            <div class="sensor_wrap_bg" @click="sensorTkClose()"></div>
            <div class="sensor_box" :class="{'sensor_tk_show':sensorTkShow}">
                <div class="sensor_title">
                    <span class="span1">{{sensorTkTitle}}</span>
                    <span class="span2" @click="sensorTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="form">
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text42')}}</span>
                        <el-input v-model="sensorForm.name" placeholder="Please enter device name"></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room_light.text57')}}</span>
                        <el-dropdown @command="commandModelSensor" trigger="click" @visible-change="commandHide('dropdown_lights_model')">
                            <span class="span1">{{sensorFormModelName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_lights_model">
                                <el-dropdown-item v-for="item in modelNavSensor" :command="item" :key="'floor'+item.id" :class="{'select':item.id==sensorForm.model}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text18')}}</span>
                        <el-input v-model="sensorForm.deviceId" placeholder="Please enter device id"></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text22')}}</span>
                        <el-dropdown @command="commandFloorSensor" trigger="click" @visible-change="commandHide('dropdown_sensor_floor')">
                            <span class="span1">{{sensorFormFloorName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_sensor_floor">
                                <el-dropdown-item v-for="item in floorNav" :command="item" :key="'floor'+item.id" :class="{'select':item.id==sensorForm.floorId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text23')}}</span>
                        <el-dropdown @command="commandRoomSensor" trigger="click" @visible-change="commandHide('dropdown_sensor_room')">
                            <span class="span1">{{sensorFormRoomName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_sensor_room">
                                <el-dropdown-item v-for="item in roomNav" :command="item" :key="'room'+item.id"  :class="{'select':item.id==sensorForm.roomId}">{{item.number}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="postSaveLight(deviceType)">{{$t('App.room.text35')}}</div>
                </div>
            </div>
        </div>
        <!-- air purifier -->
        <div class="purifier_wrap scrollbar_style" v-show="purifierTkShowbg">
            <div class="purifier_wrap_bg" @click="purifierTkClose()"></div>
            <div class="purifier_box" :class="{'purifier_tk_show':purifierTkShow}">
                <div class="purifier_title">
                    <span class="span1">{{purifierTkTitle}}</span>
                    <span class="span2" @click="purifierTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="form">
                    <div class="form_item">
                        <span class="laber">{{$t('App.room_light.text14')}}</span>
                        <el-input v-model="purifierForm.name" placeholder="Please enter device name"></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room_light.text57')}}</span>
                        <el-dropdown @command="commandModelPurifier" trigger="click" @visible-change="commandHide('dropdown_lights_model')">
                            <span class="span1">{{purifierFormModelName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_lights_model">
                                <el-dropdown-item v-for="item in modelNavPurifier" :command="item" :key="'floor'+item.id" :class="{'select':item.id==purifierForm.model}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text18')}}</span>
                        <el-input v-model="purifierForm.deviceId" placeholder="Please enter device id"></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room_light.text58')}}</span>
                        <el-input v-model="purifierForm.gatewayId" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text22')}}</span>
                        <el-dropdown @command="commandFloorPurifier" trigger="click" @visible-change="commandHide('dropdown_air_floor')">
                            <span class="span1">{{purifierFormFloorName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_air_floor">
                                <el-dropdown-item v-for="item in floorNav" :command="item" :key="'floor'+item.id" :class="{'select':item.id==purifierForm.floorId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text23')}}</span>
                        <el-dropdown @command="commandRoomPurifier" trigger="click" @visible-change="commandHide('dropdown_air_room')">
                            <span class="span1">{{purifierFormRoomName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_air_room">
                                <el-dropdown-item v-for="item in roomNav" :command="item" :key="'room'+item.id" :class="{'select':item.id==purifierForm.roomId}">{{item.number}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="postSaveLight(deviceType)">{{$t('App.room.text35')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import colorPicker from '../components/colorPicker'

    import { mapGetters } from 'vuex'
    import allUrl from '../api/allUrl.js'
    import base from '../api/base.js'
    export default {
        name: 'room-light',
        data () {
            return {
                lampGuangBoHLCColor:0,
                lampGuangBoHLCLight:0,

                newTimeDataTime:null,
                newTimeData:{
                    time_zone:'',
                    time:'',
                    wakeupTime:'',
                    pattern:'',
                    setting:'',
                },
                timeArr1:['00','01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23'],
                timeArr2:['00','01','02','03','04','05','06'],

                bottomDemoTime1:0,
                bottomDemoTime2:0,
                bottomDemoTime3:0,
                bottomDemoTime4:0,

                bottomDemoTime1_:0,
                bottomDemoTime2_:0,
                bottomDemoTime3_:0,
                bottomDemoTime4_:0,

                roomId:'',
                roomName:'',
                buildId:'',
                buildName:'',
                lightId:'',

                deviceList:[],
                lampCmdData:{
                    name:'',
                    deviceId:'',
                    model:'',
                    light:0,
                    status:0,
                    status_:0,
                    online:null,
                    blueStatus:null,
                    alarmStatus:0,
                    color:0,
                    colorR:0,
                    colorG:0,
                    colorB:0,
                    loading_0:false,
                },
                colorR_:null,
                colorG_:null,
                colorB_:null,
                lampColorRgbIndex:0,

                sensorId:'',
                sensorInfoData:{
                    name:'',
                    deviceId:'',
                    floorId:'',
                    roomId:'',
                    pm25:'',
                    pm10:'',
                    formaldehyde:'',
                    temperature:'',
                    humidity:'',
                    co2:'',
                    illuminance:'',
                    noise:'',
                    batteryLevel:'',
                    batteryStatus:'',
                    online:'',
                    wifiLevel:'0',
                    useTime:'',
                    alarmStatus:'',
                    alarmInfo:'',
                },

                sensorTkShowbg:false,
                sensorTkShow:false,
                sensorForm:{
                    name:'',
                    deviceId:'',
                    floorId:'',
                    roomId:'',
                    model:'',
                    // type:'0',
                },
                sensorFormFloorName:'',
                sensorFormRoomName:'',
                sensorTkTitle:'',
                sensorStatusArr:[],

                batteryStatusArr:['NA','Fault'],
                onlineArr:['Off-line','On-line'],
                levelArr:['Low','Middle','High'],

                purifierId:'',
                purifierInfoData:{
                    name:'',
                    deviceId:'',
                    online:'',
                    blueStatus:'',
                    useTime:'',
                    workTime:'',
                    alarmStatus:null,
                    status:null,
                    status_:null,
                    level:null,
                    level_:null,
                },
                trunOffDeviceLoadingIndex:0,
                trunOffDeviceLoading:false,
                purifierReport:{},
                purifierFormNew:{
                    uTime:null,
                    purModel:'0',
                    startTime:'',
                    endTime:'',
                    pm25_level1:'',
                    pm25_level2:'',
                    pm25_level3:'',
                    pm10_level1:'',
                    pm10_level2:'',
                    pm10_level3:'',
                    co2_level1:'',
                    co2_level2:'',
                    co2_level3:'',
                    tvoc_level1:'',
                    tvoc_level2:'',
                    tvoc_level3:'',
                    hcho_level1:'',
                    hcho_level2:'',
                    hcho_level3:'',
                },
                purModelArr:[{id:'0',name:'Manual mode'},{id:'1',name:'Auto mode'}],

                purifierTkShowbg:false,
                purifierTkShow:false,
                purifierForm:{
                    name:'',
                    model:'',
                    deviceId:'',
                    floorId:'',
                    roomId:'',
                    gatewayId:'',
                    uTime:null,
                    purModel:'0',
                    shutStart:null,
                    shutStop:null,
                    lowStart:null,
                    lowStop:null,
                    midStart:null,
                    midStop:null,
                    highStart:null,
                    highStop:null,
                },
                purifierFormFloorName:'',
                purifierFormRoomName:'',
                purifierTkTitle:'',

                lampCmdDataLight:0,
                lampCmdDataLight_:0,
                lampCmdDataColor:0,
                lampCmdDataColor_:0,
                lampCmdDataColor_circadian:-1,
                lampCmdDataColor_circadian_:-1,
                circadianColorArr:[1200,1500,2000,2500,2700,3000,3500,4000,4500,5000,5500,5700,6000,6300,6500],
                colorValue:null,

                dataColorTime1:'00',
                dataColorTime2:'00',
                dataColorTime3:'00',
                dataColorTime4:'00',
                dataColorTimeChangetime:null,
                colorTime:null,
                dataColorInput0:0,
                dataColorInput1:0,
                dataColorInput2:0,
                dataColorInput3:0,
                databrightnessInput0:0,
                databrightnessInput1:0,
                databrightnessInput2:0,
                dataColorTempInput0:0,
                dataColorTempInput1:0,
                dataColorTempInput2:0,
                dataColorTempInput3:0,

                chartType:'0',
                chartTypeStr:'line',
                chartTypeArr:[{label:'Line',value:'0',str:'line'},{label:'Bar',value:'1',str:'bar'}],
                timeType1:'0',
                timeType2:'0',
                timeType3:'0',
                timeType4:'0',
                timeTypeStr1:'Daily',
                timeTypeStr2:'Daily',
                timeTypeStr4:'Daily',
                timeTypeArr:[{label:'Daily',value:'0'},{label:'Weekly',value:'4'},{label:'Monthly',value:'1'},{label:'Yearly',value:'2'}],

                roomLightBoottomNavVal:1,
                roomLightBoottomNavVal1:false,
                roomLightBoottomNavVal2:false,
                roomLightBoottomNavVal3:false,
                roomLightBoottomNavVal4:false,
                roomLightBoottomNavVal5:false,

                cirdadianLights:false,

                echartsName1:'',
                echartsName2:'',
                echartsName3:'',
                echartsName4:'',
                echartsName5:'',
                echartsName6:'',
                echartsName7:'',

                value:0,
                value4:'',
                deviceType:null,
                deviceInfoType:'1',
                deviceInfoTypeTitle1:'Device Management',
                deviceInfoTypeTitle2:'Information',
                deviceId:null,
                deviceId_:null,
                options:[],
                historyShowbg:false,
                historyShow:false,

                lightStatus:'0',
                crcLightStatus:'0',
                sensorStatus:'0',
                purifierStatus:'0',

                hasLight:'0',
                hasCrcLight:'0',
                hasSensor:'0',
                hasPurifier:'0',

                buildNav:[],

                websocket1:null,
                websocket2:null,
                websocket3:null,
                clientId:'',

                level_:'',
                lightsTkShowbg:false,
                lightsTkShow:false,
                lightsForm:{
                    name:'',
                    deviceId:'',
                    floorId:'',
                    roomId:'',
                    model:'',
                    // type:'0',
                },
                modelNavLight:[{id:'0',name:'WE-L10'},{id:'1',name:'WE-L20'},{id:'2',name:'WE-CL10'},{id:'3',name:'WE-CL20'},{id:'4',name:'WE-L10-EP'},{id:'5',name:'WE-L20-EP'},{id:'6',name:'WE-CL10-EP'}],
                modelNavCirLight:[{id:'2',name:'WE-CL10'},{id:'3',name:'WE-CL20'}],
                modelNavSensor:[],
                modelNavPurifier:[],
                lightsFormFloorName:'',
                lightsFormRoomName:'',
                lightTkTitle:'',
                floorNav:[],
                roomNav:[],

                myChart1:null,
                myChart2:null,

                timeoutSleep:null,

                loading:{
                    lampLight:false,
                    lampColor:false,
                    lampColorRgb:false,
                    updateSensorInfo:false,
                    deviceList:false,
                    sunriseSunsetType:false,
                    getHotelForecast:false,
                    lightStyleFun:false,
                    run:false,
                    roomLightBoottomNavFun:false,
                    commandPurifierSetting:false,
                    sensorSet_status:false,
                    guangbo_dim:false,
                },

                cirLightsPlanId:'',
                // cirLightsPlanName:'',
                cirLightsPlanList:[],

                postLampColorTime:null,
                postLampLightTime:null,

                lightTestIndex:0,
                lightTestIndexArr:['-','05:45','05:50','06:00','06:30','06:50','07:10','07:30','07:50','08:10','08:30','09:00','09:40','10:20','11:00','12:00','13:00','13:40','14:20','15:00','15:30','16:00','16:30','17:00','17:15','17:30','18:00','19:00','20:00','21:00'],

                runTime0:0,
                runTime1:0,
                runTime2:0,
                runTime3:0,
                runTime4:'AM',

                runColor0:0,
                runColor1:0,
                runColor2:0,
                runColor3:0,
                runCirDevDate:'',

                img_device_0:'',
                img_device_1:'',
                img_device_2:'',
                img_device_3:'',
                img_sensor_icon:'',
            }
        },
        components:{
            'colorPicker':colorPicker
        },
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',

                updateRemRatio:'updateRemRatio',

                countryId:'countryId',
                provinceId:'provinceId',
                cityId:'cityId',
                hotelId:'hotelId',
                remRatio:'remRatio',
                domainName: 'domainName',
            }),
            purifierSettingFormPurModel(){
                let name = '';
                for(let d of this.purModelArr){
                    if(d.id == this.purifierFormNew.purModel){
                        name = d.name
                    }
                }
                return name
            },
            lightsFormModelName(){
                let name = '';
                for(let d of this.modelNavLight){
                    if(d.id == this.lightsForm.model){
                        name = d.name
                    }
                }
                return name
            },
            cirLightsFormModelName(){
                let name = '';
                for(let d of this.modelNavCirLight){
                    if(d.id == this.lightsForm.model){
                        name = d.name
                    }
                }
                return name
            },
            sensorFormModelName(){
                let name = '';
                for(let d of this.modelNavSensor){
                    if(d.id == this.sensorForm.model){
                        name = d.name
                    }
                }
                return name
            },
            purifierFormModelName(){
                let name = '';
                for(let d of this.modelNavPurifier){
                    if(d.id == this.purifierForm.model){
                        name = d.name
                    }
                }
                return name
            },
            // cirLightsPlanName(){
            //     let name = '';
            //     for(let d of this.cirLightsPlanList){
            //         if(d.id == this.cirLightsPlanId){
            //             name = d.cvsname
            //         }
            //     }
            //     return name
            // },
        },
        beforeDestroy(){
            if(this.websocket1){
                this.websocket1.close()
            }
            if(this.websocket2){
                this.websocket2.close()
            }
            if(this.websocket3){
                this.websocket3.close()
            }
        },
        mounted(){
            this.img_device_0 = require('../img/device_0_1.png');
            this.img_device_1 = require('../img/device_1_1.png');
            this.img_device_2 = require('../img/device_2_1.png');
            this.img_device_3 = require('../img/device_3_1.png');
            this.img_sensor_icon = require('../img/sensor_icon.png');
            // if(this.version == 1){
            //     this.img_device_0 = require('../img/device_0_2_v1.png');
            //     this.img_device_1 = require('../img/device_1_2_v1.png');
            //     this.img_device_2 = require('../img/device_2_2_v1.png');
            //     this.img_device_3 = require('../img/device_3_2_v1.png');
            //     this.img_sensor_icon = require('../img/sensor_icon_v1.png');
            // }

            this.batteryStatusArr = [this.$t('App.room_light.text71'),this.$t('App.room_light.text60')];
            this.onlineArr = [this.$t('App.room.text65'),this.$t('App.room.text66')];
            this.levelArr = [this.$t('App.room.text68'),this.$t('App.room.text69'),this.$t('App.room.text70')];
            // this.levelArr = [this.$t('App.room.text67'),this.$t('App.room.text68'),this.$t('App.room.text69'),this.$t('App.room.text70')];

            this.chartTypeStr = 'line';
            this.chartTypeArr = [{label:this.$t('App.room_light.text61'),value:'0',str:'line'},{label:this.$t('App.room_light.text62'),value:'1',str:'bar'}];

            this.timeTypeStr1 = this.$t('App.room_light.text63');
            this.timeTypeStr2 = this.$t('App.room_light.text63');
            this.timeTypeStr4 = this.$t('App.room_light.text63');
            this.timeTypeArr = [{label:this.$t('App.room_light.text63'),value:'0'},{label:this.$t('App.room_light.text64'),value:'4'},{label:this.$t('App.room_light.text65'),value:'1'},{label:this.$t('App.room_light.text66'),value:'2'}];

            this.deviceInfoTypeTitle1 = this.$t('App.room_light.text6');
            this.deviceInfoTypeTitle2 = this.$t('App.room_light.text67');

            this.purModelArr = [{id:'0',name:this.$t('App.airPurifiers.text12')},{id:'1',name:this.$t('App.airPurifiers.text13')},{id:'2',name:this.$t('App.airPurifiers.text24')}];
            
            this.sensorStatusArr = [this.$t('App.lights.text48'),this.$t('App.lights.text49')];

            for(let i = 1;i<3;i++){
                let val = i<10?'0'+i:i;
                let id = 72 + i;
                this.$set(this.modelNavLight,this.modelNavLight.length,{id:id,name:'IH-DM'+val})
            }
            for(let i = 1;i<3;i++){
                let val = i<10?'0'+i:i;
                let id = 82 + i;
                this.$set(this.modelNavLight,this.modelNavLight.length,{id:id,name:'IH-DE'+val})
            }

            for(let i = 1;i<3;i++){
                let val = i<10?'0'+i:i;
                let id = 72 + i;
                this.$set(this.modelNavCirLight,this.modelNavCirLight.length,{id:id,name:'IH-DM'+val})
            }
            for(let i = 1;i<3;i++){
                let val = i<10?'0'+i:i;
                let id = 82 + i;
                this.$set(this.modelNavCirLight,this.modelNavCirLight.length,{id:id,name:'IH-DE'+val})
            }
            for(let i = 1;i<6;i++){
                let val = i<10?'0'+i:i;
                let id = 32 + i;
                this.$set(this.modelNavCirLight,this.modelNavCirLight.length,{id:id,name:'IH-DL'+val})
            }
            for(let i = 1;i<4;i++){
                let val = i<10?'0'+i:i;
                let id = 42 + i;
                this.$set(this.modelNavCirLight,this.modelNavCirLight.length,{id:id,name:'IH-PL'+val})
            }

            for(let i = 1;i<4;i++){
                let val = i<10?'0'+i:i;
                let id = 52 + i;
                this.$set(this.modelNavSensor,this.modelNavSensor.length,{id:id,name:'IH-SR'+val})
            }

            for(let i = 1;i<4;i++){
                let val = i<10?'0'+i:i;
                let id = 52 + i;
                this.$set(this.modelNavPurifier,this.modelNavPurifier.length,{id:id,name:'IH-AP'+val})
            }

            
            for(let i = 0;i<60;i++){
                let val = i;
                if(i<10){
                    val = '0'+i;
                }
                this.$set(this.timeArr2,i,val)
            }
            var storage = window.localStorage;
            if(storage.getItem('hotelIdNav')&&!this.hotelId){
                this.$store.commit('HEADERIDFUN',{
                    hotelId:storage.getItem('hotelIdNav'),
                })
            }
            this.roomId = storage.getItem('roomRoomId');
            this.roomName = storage.getItem('roomRoomName');
            this.buildId = storage.getItem('buildId');
            this.buildName = storage.getItem('buildIdName');
            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:false,
            })
            if(storage.getItem('deviceType')){
                this.deviceType = storage.getItem('deviceType');
            }else{
                this.deviceType = '0'
            }
            if(this.deviceType == '0' || this.deviceType == '1'){
                this.getlightList(this.deviceType,data=>{
                    if(data.data.list.length > 0){
                        this.deviceId = data.data.list[0].id;
                        this.deviceId_ = data.data.list[0].id;
                        this.lightId = data.data.list[0].id;
                        this.getLightInfo(data.data.list[0].id,()=>{
                            this.getEnergyConsumption(this.lightId,this.deviceType == '0'?this.timeType1:this.timeType2);
                        })
                    }
                });
            }
            // this['img_device_'+this.deviceType] = require('../img/device_'+this.deviceType+'_2.png');
            if(this.deviceType == '2'){
                this.getSensorList(data=>{
                    if(data.data.list.length > 0){
                        this.deviceId = data.data.list[0].id;
                        this.deviceId_ = data.data.list[0].id;
                        this.sensorId = data.data.list[0].id;
                        this.getSensorInfo(data.data.list[0].id)
                    }
                });
            }
            if(this.deviceType == '3'){
                this.getPurifierList(data=>{
                    if(data.data.list.length > 0){
                        this.deviceId = data.data.list[0].id;
                        this.deviceId_ = data.data.list[0].id;
                        this.purifierId = data.data.list[0].id;
                        this.getPurifierInfo(data.data.list[0].id,()=>{
                            this.getPurifierReport(this.timeType4,data=>{
                                this.energyConsumption({dataList:data.data.workTimeList,timeList:data.data.timeList},'h')
                            })
                        })
                        this.get_mode_and_time(this.purifierId,data=>{
                            for(let key in data.data){
                                this.purifierFormNew[key] = data.data[key];
                            }
                        })
                    }
                });
            }

            base.websocket(allUrl.websocket.ws,websocket=>{
                this.websocket1 = websocket;
                websocket.send('{"type":"roomInfo","roomId":'+this.roomId+'}');
                websocket.onmessage = event => {
                    // console.log(JSON.parse(event.data));
                    let data = JSON.parse(event.data)
                    this.hasLight = data.hasLight;
                    this.hasCrcLight = data.hasCrcLight;
                    this.hasSensor = data.hasSensor;
                    this.hasPurifier = data.hasPurifier;
                    if(data.hasLight == '1'){
                        if(data.lightAlarm == '1'){
                            this.lightStatus = '1_0';
                        }else{
                            if(data.lightStatus == '1'){
                                this.lightStatus = '1';
                            }else{
                                this.lightStatus = '0_0';
                            }
                        }
                    }
                    if(data.hasCrcLight == '1'){
                        if(data.crcLightAlarm == '1'){
                            this.crcLightStatus = '1_0';
                        }else{
                            if(data.crcLightStatus == '1'){
                                this.crcLightStatus = '1';
                            }else{
                                this.crcLightStatus = '0_0';
                            }
                        }
                    }
                    if(data.hasSensor == '1'){
                        if(data.sensorAlarm == '1'){
                            this.sensorStatus = '1_0';
                        }else{
                            if(data.sensorStatus == '1'){
                                this.sensorStatus = '1';
                            }else{
                                this.sensorStatus = '0_0';
                            }
                        }
                    }
                    if(data.hasPurifier == '1'){
                        if(data.purifierAlarm == '1'){
                            this.purifierStatus = '1_0';
                        }else{
                            if(data.purifierStatus == '1'){
                                this.purifierStatus = '1';
                            }else{
                                this.purifierStatus = '0_0';
                            }
                        }
                    }

                }
            })
            base.websocket(allUrl.websocket.ws,websocket=>{
                this.websocket2 = websocket;
                websocket.send('{"type":"cmd"}');
                websocket.onmessage = event => {
                    // console.log(JSON.parse(event.data));
                    let data = JSON.parse(event.data)
                    if(data.code == '0000'){
                        if(data.data.status == '1'){
                            this.clientId = data.data.clientid
                        }
                        if(data.data.status == '2'){
                            if(data.data.type == 'Turn'){
                                this.$notify({
                                    title: data.msg,
                                    message: this.$t('App.room_light.text70')+data.data.name,
                                    type: 'success'
                                });
                                if(this.deviceId != '-1'){
                                    this.getLightInfo(this.lightId)
                                }
                                for(let d of this.deviceList){
                                    if(d.id == data.data.id){
                                        d.loading_0 = false;
                                        d.status = d.status==d.status_?this.lampCmdData.status:d.status;
                                        d.status_ = d.status==d.status_?this.lampCmdData.status:d.status;
                                    }
                                }
                                this.lampCmdData.status_ = this.lampCmdData.status;
                            }
                            if(data.data.type == 'trun_off'){
                                this.$notify({
                                    title: data.msg,
                                    message: this.$t('App.room_light.text70')+data.data.name,
                                    type: 'success'
                                });
                                // this.trunOffDeviceLoading = false;
                                this.trunOffDeviceLoadingIndex--;
                                if(this.trunOffDeviceLoadingIndex <= 0){
                                    this.trunOffDeviceLoadingIndex = 0;
                                    this.trunOffDeviceLoading = false;
                                }
                            }
                            if(data.data.type == 'Dimming'){
                                this.$notify({
                                    title: data.msg,
                                    message: this.$t('App.room_light.text70')+data.data.name,
                                    type: 'success'
                                });
                                // this.loading.lampLight = false;
                                this.lampCmdData.light = this.lampCmdDataLight;
                                if(this.deviceId != '-1'){
                                    this.getLightInfo(this.lightId)
                                }
                                console.log(this.lampCmdDataLight,'--------')
                                for(let d of this.deviceList){
                                    if(d.id == data.data.id){
                                        d.loading_0 = false;
                                        if(this.lampCmdDataLight>0){
                                            d.status = 1;
                                            this.lampCmdData.status = 1;
                                        }else{
                                            d.status = 0;
                                            this.lampCmdData.status = 0;
                                        }
                                        d.brightness = this.lampCmdDataLight;
                                    }
                                }
                                // console.log('----------')
                            }
                            if(data.data.type == 'Color'){
                                this.$notify({
                                    title: data.msg,
                                    message: this.$t('App.room_light.text70')+data.data.name,
                                    type: 'success'
                                });
                                this.loading.lampColor = false;
                                if(this.deviceType == '1'){
                                    this.lampCmdData.color = parseInt(this.circadianColorArr[this.lampCmdDataColor_circadian])
                                }else{
                                    this.lampCmdData.color = this.lampCmdDataColor;
                                }
                                for(let d of this.deviceList){
                                    if(d.id == data.data.id){
                                        if(this.deviceType == '1'){
                                             d.color = parseInt(this.circadianColorArr[this.lampCmdDataColor_circadian])
                                        }else{
                                             d.color = this.lampCmdDataColor;
                                        }
                                    }
                                }
                            }
                            if(data.data.type == 'Color_rgb'){
                                this.$notify({
                                    title: data.msg,
                                    message: this.$t('App.room_light.text70')+data.data.name,
                                    type: 'success'
                                });
                                // this.loading.lampColorRgb = false;
                                for(let d of this.deviceList){
                                    if(d.id == data.data.id){
                                        if(this.deviceType == '1'){
                                             d.color = parseInt(this.circadianColorArr[this.lampCmdDataColor_circadian])
                                        }else{
                                             d.color = this.lampCmdDataColor;
                                        }
                                    }
                                }
                                this.lampColorRgbIndex--;
                                if(this.lampColorRgbIndex <= 0){
                                    this.lampColorRgbIndex = 0;
                                    this.loading.lampColorRgb = false;
                                }
                            }
                            if(data.data.type == 'get_hotel_pattern'){
                                this.loading.roomLightBoottomNavFun = false;
                                this.$message({
                                    showClose: true,
                                    message: data.msg,
                                    type: 'success'
                                });
                                if(this.roomLightBoottomNavVal == '2' && this.roomLightBoottomNavVal1){
                                    if(this.roomLightBoottomNavVal2){
                                        this.roomLightBoottomNavVal3 = false;
                                        this.roomLightBoottomNavVal4 = false;
                                        this.roomLightBoottomNavVal5 = false;
                                        this.cirdadianLights = false;
                                    }
                                }
                                if(this.roomLightBoottomNavVal == '3' && this.roomLightBoottomNavVal1){
                                    if(this.roomLightBoottomNavVal3){
                                        this.roomLightBoottomNavVal2 = false;
                                        this.roomLightBoottomNavVal4 = false;
                                        this.cirdadianLights = false;
                                    }
                                }
                                if(this.roomLightBoottomNavVal == '4' && this.roomLightBoottomNavVal1){
                                    if(this.roomLightBoottomNavVal4){
                                        this.roomLightBoottomNavVal2 = false;
                                        this.roomLightBoottomNavVal3 = false;
                                        this.cirdadianLights = false;
                                    }
                                }
                            }
                            if(data.data.type == 'sensor_set_status'){
                                this.loading.sensorSet_status = false;
                                this.$message({
                                  showClose: true,
                                  message: data.msg,
                                  type: 'success'
                                });
                            }


                        }
                    }else{
                        this.$alert(data.msg, this.$t('App.message.text1'), {
                            confirmButtonText: this.$t('App.message.text2'),
                        });
                        if(data.data.status == '2'){
                            if(data.data.type == 'Turn'){
                                if(this.deviceId != '-1'){
                                    this.getLightInfo(this.lightId)
                                }
                                for(let d of this.deviceList){
                                    if(d.id == data.data.id){
                                        d.status = d.status_;
                                        d.loading_0 = false;
                                        console.log(d.id,d.status_,'------')
                                    }
                                }
                                this.lampCmdData.status = this.lampCmdData.status_;
                                // this.lampCmdData.loading_0 = false;
                            }
                            if(data.data.type == 'trun_off'){
                                for(let d of this.deviceList){
                                    if(d.id == data.data.id){
                                        d.status = d.status_;
                                        d.level = d.level_;
                                    }
                                }
                                this.purifierInfoData.status = this.purifierInfoData.status_;
                                this.purifierInfoData.level = this.purifierInfoData.level_;
                                // this.trunOffDeviceLoading = false;
                                this.trunOffDeviceLoadingIndex--;
                                if(this.trunOffDeviceLoadingIndex <= 0){
                                    this.trunOffDeviceLoadingIndex = 0;
                                    this.trunOffDeviceLoading = false;
                                }
                            }
                            if(data.data.type == 'Dimming'){
                                if(this.deviceId != '-1'){
                                    this.lampCmdDataLight = this.lampCmdDataLight_;
                                    this.getLightInfo(this.lightId)
                                }
                                for(let d of this.deviceList){
                                    if(d.id == data.data.id){
                                        d.loading_0 = false;
                                    }
                                }
                                // this.loading.lampLight = false;
                            }
                            if(data.data.type == 'Color'){
                                if(this.deviceType == '1'){
                                    this.lampCmdDataColor_circadian = this.lampCmdDataColor_circadian_
                                }else{
                                    this.lampCmdDataColor = this.lampCmdDataColor_
                                }
                                this.loading.lampColor = false; 
                            }
                            if(data.data.type == 'Color_rgb'){
                                this.lampColorRgbIndex--;
                                if(this.lampColorRgbIndex <= 0){
                                    this.lampColorRgbIndex = 0;
                                    this.loading.lampColorRgb = false;
                                }
                            }
                            if(data.data.type == 'get_hotel_pattern'){
                                this.loading.roomLightBoottomNavFun = false;

                                if(val == '1'){
                                    if(this.roomLightBoottomNavVal1){
                                        this.roomLightBoottomNavVal1 = false;
                                    }else{
                                        this.roomLightBoottomNavVal1 = true;
                                    }
                                }
                                if(val == '2' && this.roomLightBoottomNavVal1){
                                    if(this.roomLightBoottomNavVal2){
                                        this.roomLightBoottomNavVal2 = false;
                                    }else{
                                        this.roomLightBoottomNavVal2 = true;
                                    }
                                }
                                if(val == '3' && this.roomLightBoottomNavVal1){
                                    if(this.roomLightBoottomNavVal3){
                                        this.roomLightBoottomNavVal3 = false;
                                    }else{
                                        this.roomLightBoottomNavVal3 = true;
                                    }
                                }
                                if(val == '4' && this.roomLightBoottomNavVal1){
                                    if(this.roomLightBoottomNavVal4){
                                        this.roomLightBoottomNavVal4 = false;
                                    }else{
                                        this.roomLightBoottomNavVal4 = true;
                                    }
                                }
                                if(this.roomLightBoottomNavVal == '5'){
                                    if(this.roomLightBoottomNavVal5){
                                        this.roomLightBoottomNavVal5 = false;
                                    }else{
                                        this.roomLightBoottomNavVal5 = true;
                                    }
                                }
                            }
                            if(data.data.type == 'sensor_set_status'){
                                this.loading.sensorSet_status = false;
                                if(this.sensorInfoData.status == '1'){
                                    this.sensorInfoData.status = '0'
                                }else{
                                    this.sensorInfoData.status = '1'
                                }
                            }
                        }
                            
                    }
                }
            },this)
            this.getPlan();
            this.newTime();
        },
        methods:{
            guangbo_dimSave(){
                if(!this.loading.guangbo_dim){
                    this.loading.guangbo_dim = true;

                    base.ajax_post(
                        allUrl.room.guangbo_dim,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            roomId:this.roomId,
                            light:this.lampGuangBoHLCLight,
                            color:this.circadianColorArr[this.lampGuangBoHLCColor],
                        },
                        {},
                        data=>{
                            this.$message({
                              showClose: true,
                              message: data.msg,
                              type: 'success'
                            });
                            this.loading.guangbo_dim = false;
                        },
                        this,()=>{
                            this.loading.guangbo_dim = false;
                        }
                    )
                }
            },
            sensorSet_status(){
                if(!this.loading.sensorSet_status){
                    this.loading.sensorSet_status = true;
                    if(this.sensorInfoData.status == '1'){
                        this.sensorInfoData.status = '0'
                    }else{
                        this.sensorInfoData.status = '1'
                    }
                    base.ajax_postWs(
                        allUrl.roomLight.set_status,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            clientId:this.clientId,
                            id:this.sensorId,
                            status:this.sensorInfoData.status,
                        },
                        this
                    )
                }
            },
            commandPurifierSetting(data){
                let purModel = this.purifierFormNew.purModel;
                if(!this.loading.commandPurifierSetting){
                    this.purifierFormNew.purModel = data.id;
                    this.loading.commandPurifierSetting = true;

                    base.ajax_post(
                        allUrl.roomLight.set_mode_and_time,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            purifierId:this.purifierId,
                            ...this.purifierFormNew
                        },
                        {},
                        data=>{
                            this.$message({
                              showClose: true,
                              message: data.msg,
                              type: 'success'
                            });
                            this.loading.commandPurifierSetting = false;
                        },
                        this,()=>{
                            this.purifierFormNew.purModel = purModel;
                            this.loading.commandPurifierSetting = false;
                        }
                    )
                }
            },
            get_mode_and_time(id,callback){
                base.ajax_post(
                    allUrl.roomLight.get_mode_and_time,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        purifierId:id,
                    },
                    {},
                    data=>{
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            lightTest(){
                // let this_ = this;
                if(this.lightTestIndex == 0){
                    this.roomLightBoottomNavVal2 = false;

                    base.ajax_post(
                        allUrl.roomLight.lightTest,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            id:this.lightId,
                            pattern:8,
                        },
                        {},
                        data=>{
                            console.log(data)
                            if(this.loading.run){
                                return
                            }
                            this.loading.run = true;
                            base.websocket(allUrl.websocket.ws,websocket=>{
                                this.websocket1 = websocket;
                                websocket.send('{"type":"runCirDev","id":"'+this.lightId+'"}');
                                websocket.onmessage = event => {
                                    let data = JSON.parse(event.data)
                                    if(data.code == '0000'){
                                        if(data.data.status == '2'){
                                            if(data.data.type == 'runCirDev'){
                                                this.loading.run = false;
                                                console.log(data.data.time.split(' ')[0])
                                                for(let key in this.lightTestIndexArr){
                                                    if(this.lightTestIndexArr[key] == data.data.time.split(' ')[0]){
                                                        this.lightTestIndex = key;
                                                    }
                                                }
                                                // if(this.runCirDevDate != data.data.time){
                                                //     this.runCirDevDate = data.data.time;
                                                //     this.lightTestIndex++;
                                                // }
                                                // if(this.lightTestIndex >29){
                                                //     this.lightTestIndex = 29;
                                                // }
                                                this.runTime0 = data.data.time.split(':')[0].split('')[0];
                                                this.runTime1 = data.data.time.split(':')[0].split('')[1];
                                                this.runTime2 = data.data.time.split(':')[1].split('')[0];
                                                this.runTime3 = data.data.time.split(':')[1].split('')[1];

                                                this.runTime4 = data.data.time.split(' ')[1];

                                                data.data.color = data.data.color+'';
                                                this.runColor0 = data.data.color.split('')[0];
                                                this.runColor1 = data.data.color.split('')[1];
                                                this.runColor2 = data.data.color.split('')[2];
                                                this.runColor3 = data.data.color.split('')[3];
                                                if(data.data.is_end == 1){
                                                    this.lightTestIndex = 0;
                                                }
                                            }
                                        }
                                    }else{
                                        this.$alert(data.msg, this.$t('App.message.text1'), {
                                            confirmButtonText: this.$t('App.message.text2'),
                                        });
                                        this.lightTestIndex = 0;
                                    }
                                }
                            })
                        },
                        this
                    )
                }
            },
            newTime(){
                base.ajax_post(
                    allUrl.roomLight.newTime,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        hotelId:this.hotelId,
                        roomId:this.roomId,
                    },
                    {},
                    data=>{
                        let this_ = this;
                        this.newTimeData = data.data;
                        if(data.data.time){
                            let timeh = Number(data.data.time.split(' ')[1].split(':')[0]);
                            let timem = Number(data.data.time.split(' ')[1].split(':')[1]);
                            let times = Number(data.data.time.split(' ')[1].split(':')[2]);
                            this.newTimeData.time = (timeh<10?'0'+timeh:timeh)+':'+(timem<10?'0'+timem:timem);
                            clearInterval(this.newTimeDataTime);
                            this.newTimeDataTime = setInterval(function(){
                                times++;
                                if(times >= 60){
                                    times = 0
                                    timem++;
                                    if(timem >= 60){
                                        timem = 0;
                                        timeh++;
                                        if(timeh>=23){
                                            timeh = 0
                                        }
                                    }
                                }
                                this_.newTimeData.time = (timeh<10?'0'+timeh:timeh)+':'+(timem<10?'0'+timem:timem);
                            },1000)
                        }

                        this.dataColorTime1 = this.newTimeData.Sunrise?this.newTimeData.Sunrise.split(':')[0]:0;
                        this.dataColorTime2 = this.newTimeData.Sunrise?this.newTimeData.Sunrise.split(':')[1]:0;
                        this.dataColorTime3 = this.newTimeData.Sunset?this.newTimeData.Sunset.split(':')[0]:0;
                        this.dataColorTime4 = this.newTimeData.Sunset?this.newTimeData.Sunset.split(':')[1]:0;

                        this.bottomDemoTime1 = this.newTimeData.wakeupTime?Number(this.newTimeData.wakeupTime.split(':')[0]):0;
                        this.bottomDemoTime2 = this.newTimeData.wakeupTime?Number(this.newTimeData.wakeupTime.split(':')[1]):0;
                        this.bottomDemoTime3 = this.newTimeData.new_sleeptime?Number(this.newTimeData.new_sleeptime.split(':')[0])+3:0;
                        this.bottomDemoTime4 = this.newTimeData.new_sleeptime?Number(this.newTimeData.new_sleeptime.split(':')[1]):0;

                        this.bottomDemoTime1_ = this.newTimeData.wakeupTime?Number(this.newTimeData.wakeupTime.split(':')[0]):'0';
                        this.bottomDemoTime2_ = this.newTimeData.wakeupTime?Number(this.newTimeData.wakeupTime.split(':')[1]):'0';
                        this.bottomDemoTime3_ = this.newTimeData.new_sleeptime?Number(this.newTimeData.new_sleeptime.split(':')[0]):'0';
                        this.bottomDemoTime4_ = this.newTimeData.new_sleeptime?Number(this.newTimeData.new_sleeptime.split(':')[1]):'0';

                        this.bottomDemoTime1_ = this.bottomDemoTime1_<10?'0'+this.bottomDemoTime1_:this.bottomDemoTime1_
                        this.bottomDemoTime2_ = this.bottomDemoTime2_<10?'0'+this.bottomDemoTime2_:this.bottomDemoTime2_
                        this.bottomDemoTime3_ = this.bottomDemoTime3_<10?'0'+this.bottomDemoTime3_:this.bottomDemoTime3_
                        this.bottomDemoTime4_ = this.bottomDemoTime4_<10?'0'+this.bottomDemoTime4_:this.bottomDemoTime4_

                        if(this.newTimeData.setting == '1'){
                            this.roomLightBoottomNavVal5 = true;
                        }else{
                            this.roomLightBoottomNavVal5 = false;
                        }
                        this.$nextTick(function(){
                            console.log($('.room-light .room-light_bottom .room-light_bottom_flex .li .li_box .wake_up_time .time_warp .time1_box'),'------',this.bottomDemoTime1)
                            $('.room-light .room-light_bottom .room-light_bottom_flex .li .li_box .wake_up_time .time_warp .time1_box').scrollTop(this.bottomDemoTime1*this.remRatio*2)
                            $('.room-light .room-light_bottom .room-light_bottom_flex .li .li_box .wake_up_time .time_warp .time2_box').scrollTop(this.bottomDemoTime2*this.remRatio*2)
                            $('.room-light .room-light_bottom .room-light_bottom_flex .li .li_box .bed_time .time_warp .time1_box').scrollTop(this.bottomDemoTime3*this.remRatio*2)
                            $('.room-light .room-light_bottom .room-light_bottom_flex .li .li_box .bed_time .time_warp .time2_box').scrollTop(this.bottomDemoTime4*this.remRatio*2)
                        })
                        if(this.newTimeData.pattern == '1'){
                            this.roomLightBoottomNavVal1 = true;
                            this.roomLightBoottomNavVal2 = false;
                            this.roomLightBoottomNavVal3 = false;
                            this.roomLightBoottomNavVal4 = false;
                        }
                        if(this.newTimeData.pattern == '2'){
                            this.roomLightBoottomNavVal1 = false;
                            this.roomLightBoottomNavVal2 = false;
                            this.roomLightBoottomNavVal3 = false;
                            this.roomLightBoottomNavVal4 = false;
                        }
                        if(this.newTimeData.pattern == '3'){
                            this.roomLightBoottomNavVal1 = true;
                            this.roomLightBoottomNavVal2 = true;
                            this.roomLightBoottomNavVal3 = false;
                            this.roomLightBoottomNavVal4 = false;
                        }
                        if(this.newTimeData.pattern == '4'){
                            this.roomLightBoottomNavVal1 = true;
                            this.roomLightBoottomNavVal2 = false;
                            this.roomLightBoottomNavVal3 = true;
                            this.roomLightBoottomNavVal4 = false;
                        }
                        if(this.newTimeData.pattern == '5'){
                            this.roomLightBoottomNavVal1 = true;
                            this.roomLightBoottomNavVal2 = false;
                            this.roomLightBoottomNavVal3 = false;
                            this.roomLightBoottomNavVal4 = true;
                        }
                        if(this.newTimeData.pattern == '6'){
                            this.roomLightBoottomNavVal1 = true;
                            this.roomLightBoottomNavVal2 = false;
                            this.roomLightBoottomNavVal3 = false;
                            this.roomLightBoottomNavVal4 = false;
                        }
                        if(this.newTimeData.pattern == '7'){
                            this.roomLightBoottomNavVal1 = true;
                            this.roomLightBoottomNavVal2 = false;
                            this.roomLightBoottomNavVal3 = false;
                            this.roomLightBoottomNavVal4 = false;
                            this.cirdadianLights = true;
                        }
                        if(this.newTimeData.pattern == '0'){
                            this.roomLightBoottomNavVal1 = true;
                            this.roomLightBoottomNavVal2 = false;
                            this.roomLightBoottomNavVal3 = false;
                            this.roomLightBoottomNavVal4 = false;
                            this.cirdadianLights = false;
                        }
                        console.log(data)
                    },
                    this
                )
            },

            timeMouseleave1(){
                let val = Math.round(($('.room-light .room-light_bottom .room-light_bottom_flex .li .li_box .wake_up_time .time_warp .time1_box').scrollTop()/this.remRatio)/2);
                let isSave = false;
                if(this.bottomDemoTime1 != val){
                    if(val*60+this.bottomDemoTime2>(this.bottomDemoTime3-4)*60+this.bottomDemoTime4){
                        this.$message.error(this.$t('App.message.text37'));
                    }else{
                        isSave = true
                    }
                    this.bottomDemoTime1 = val;
                    $('.room-light .room-light_bottom .room-light_bottom_flex .li .li_box .wake_up_time .time_warp .time1_box').scrollTop(this.bottomDemoTime1*this.remRatio*2)
                    if(isSave){
                        this.sleepOpen();
                    }else{
                        if(this.timeoutSleep){
                            clearTimeout(this.timeoutSleep)
                            this.timeoutSleep = null;
                        }
                    }
                }
            },
            timeMouseleave2(){
                let val = Math.round(($('.room-light .room-light_bottom .room-light_bottom_flex .li .li_box .wake_up_time .time_warp .time2_box').scrollTop()/this.remRatio)/2);
                let isSave = false;
                if(this.bottomDemoTime2 != val){
                    if(this.bottomDemoTime1*60+val>(this.bottomDemoTime3-4)*60+this.bottomDemoTime4){
                        this.$message.error(this.$t('App.message.text37'));
                    }else{
                        isSave = true
                    }
                    this.bottomDemoTime2 = val;
                    $('.room-light .room-light_bottom .room-light_bottom_flex .li .li_box .wake_up_time .time_warp .time2_box').scrollTop(this.bottomDemoTime2*this.remRatio*2)
                    if(isSave){
                        this.sleepOpen();
                    }else{
                        if(this.timeoutSleep){
                            clearTimeout(this.timeoutSleep)
                            this.timeoutSleep = null;
                        }
                    }
                }
            },
            bottomDemoTime1Fun(val){
                let isSave = false;
                console.log(val,this.bottomDemoTime1)
                if(this.bottomDemoTime1 != val){
                    if(val*60+this.bottomDemoTime2>(this.bottomDemoTime3-4)*60+this.bottomDemoTime4){
                        this.$message.error(this.$t('App.message.text37'));
                    }else{
                        isSave = true
                    }
                    this.bottomDemoTime1 =val
                    $('.room-light .room-light_bottom .room-light_bottom_flex .li .li_box .wake_up_time .time_warp .time1_box').scrollTop(this.bottomDemoTime1*this.remRatio*2)
                    if(isSave){
                        this.sleepOpen();
                    }else{
                        if(this.timeoutSleep){
                            clearTimeout(this.timeoutSleep)
                            this.timeoutSleep = null;
                        }
                    }
                }
            },
            bottomDemoTime2Fun(val){
                let isSave = false;
                if(this.bottomDemoTime2 != val){
                    if(this.bottomDemoTime1*60+val>(this.bottomDemoTime3-4)*60+this.bottomDemoTime4){
                        this.$message.error(this.$t('App.message.text37'));
                    }else{
                        isSave = true
                    }
                    this.bottomDemoTime2 = val
                    $('.room-light .room-light_bottom .room-light_bottom_flex .li .li_box .wake_up_time .time_warp .time2_box').scrollTop(this.bottomDemoTime2*this.remRatio*2)
                    if(isSave){
                        this.sleepOpen();
                    }else{
                        if(this.timeoutSleep){
                            clearTimeout(this.timeoutSleep)
                            this.timeoutSleep = null;
                        }
                    }
                }
            },

            timeMouseleave1_(){
                let val = Math.round(($('.room-light .room-light_bottom .room-light_bottom_flex .li .li_box .bed_time .time_warp .time1_box').scrollTop()/this.remRatio)/2);
                let isSave = false;
                if(this.bottomDemoTime3 != val){
                    if(this.bottomDemoTime1*60+this.bottomDemoTime2>(val-4)*60+this.bottomDemoTime4){
                        this.$message.error(this.$t('App.message.text37'));
                    }else{
                        isSave = true
                    }
                    this.bottomDemoTime3 = val;
                    $('.room-light .room-light_bottom .room-light_bottom_flex .li .li_box .bed_time .time_warp .time1_box').scrollTop(this.bottomDemoTime3*this.remRatio*2)
                    if(isSave){
                        this.sleepOpen();
                    }else{
                        if(this.timeoutSleep){
                            clearTimeout(this.timeoutSleep)
                            this.timeoutSleep = null;
                        }
                    }
                }
            },
            timeMouseleave2_(){
                let val = Math.round(($('.room-light .room-light_bottom .room-light_bottom_flex .li .li_box .bed_time .time_warp .time2_box').scrollTop()/this.remRatio)/2);
                let isSave = false;
                if(this.bottomDemoTime4 != val){
                    if(this.bottomDemoTime1*60+this.bottomDemoTime2>(this.bottomDemoTime3-4)*60+val){
                        this.$message.error(this.$t('App.message.text37'));
                    }else{
                        isSave = true
                    }
                    this.bottomDemoTime4 = val;
                    $('.room-light .room-light_bottom .room-light_bottom_flex .li .li_box .bed_time .time_warp .time2_box').scrollTop(this.bottomDemoTime4*this.remRatio*2)
                    if(isSave){
                        this.sleepOpen();
                    }else{
                        if(this.timeoutSleep){
                            clearTimeout(this.timeoutSleep)
                            this.timeoutSleep = null;
                        }
                    }
                }
            },
            bottomDemoTime1_Fun(val){
                console.log(val,this.bottomDemoTime1*60+this.bottomDemoTime2>(val-4)*60+this.bottomDemoTime4)
                let isSave = false;
                if(this.bottomDemoTime3 != val){
                    if(this.bottomDemoTime1*60+this.bottomDemoTime2>(val-4)*60+this.bottomDemoTime4){
                        this.$message.error(this.$t('App.message.text37'));
                    }else{
                        isSave = true
                    }
                    this.bottomDemoTime3 =val
                    $('.room-light .room-light_bottom .room-light_bottom_flex .li .li_box .bed_time .time_warp .time1_box').scrollTop(this.bottomDemoTime3*this.remRatio*2)
                    if(isSave){
                        this.sleepOpen();
                    }else{
                        if(this.timeoutSleep){
                            clearTimeout(this.timeoutSleep)
                            this.timeoutSleep = null;
                        }
                    }
                }
            },
            bottomDemoTime2_Fun(val){
                console.log(val,this.bottomDemoTime1*60+this.bottomDemoTime2>(this.bottomDemoTime3-4)*60+val)
                let isSave = false;
                if(this.bottomDemoTime4 != val){
                    if(this.bottomDemoTime1*60+this.bottomDemoTime2>(this.bottomDemoTime3-4)*60+val){
                        this.$message.error(this.$t('App.message.text37'));
                    }else{
                        isSave = true
                    }
                    this.bottomDemoTime4 = val
                    $('.room-light .room-light_bottom .room-light_bottom_flex .li .li_box .bed_time .time_warp .time2_box').scrollTop(this.bottomDemoTime4*this.remRatio*2)
                    if(isSave){
                        this.sleepOpen();
                    }else{
                        if(this.timeoutSleep){
                            clearTimeout(this.timeoutSleep)
                            this.timeoutSleep = null;
                        }
                    }
                }
            },

            getPlan(){
                base.ajax_post(
                    allUrl.roomLight.plan,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                    },
                    {},
                    data=>{
                        console.log(data.data)
                        this.cirLightsPlanList = data.data;
                    },
                    this
                )
            },
            cirLightsPlanCommand(data){
                this.cirLightsPlanId = data.id;
                // this.cirLightsPlanName = data.cvsname;

                base.ajax_post(
                    allUrl.roomLight.addplan,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        deviceId:this.deviceId,
                        plan:this.cirLightsPlanId,
                    },
                    {},
                    data=>{
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                    },
                    this
                )
            },
            /*楼层下拉列表*/
            getFloorNav(callback){
                base.ajax_post(
                    allUrl.room.floorNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                    },
                    {},
                    data=>{
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*楼间下拉列表*/
            getRoomNav(floorId,callback){
                base.ajax_post(
                    allUrl.room.roomNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                        floorId:floorId,
                    },
                    {},
                    data=>{
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            commandModel(data){
                this.lightsForm.model = data.id;
            },
            commandModelSensor(data){
                this.sensorForm.model = data.id;
            },
            commandModelPurifier(data){
                this.purifierForm.model = data.id;
            },
            commandFloorLights(data){
                this.lightsForm.floorId = data.id;
                this.lightsFormFloorName = data.name;
                this.getRoomNav(this.lightsForm.floorId,data=>{
                    this.roomNav = data.data.list;
                    this.lightsForm.roomId = '';
                    this.lightsFormRoomName = ''
                });
                this.lightsForm.roomId = '';
            },
            commandRoomLights(data){
                this.lightsForm.roomId = data.id;
                this.lightsFormRoomName = data.number;
            },
            commandFloorSensor(data){
                this.sensorForm.floorId = data.id;
                this.sensorFormFloorName = data.name;
                this.getRoomNav(this.sensorForm.floorId,data=>{
                    this.roomNav = data.data.list;
                    this.sensorForm.roomId = '';
                    this.sensorFormRoomName = ''
                });
                this.sensorForm.roomId = '';
            },
            commandRoomSensor(data){
                this.sensorForm.roomId = data.id;
                this.sensorFormRoomName = data.number;
            },
            commandFloorPurifier(data){
                this.purifierForm.floorId = data.id;
                this.purifierFormFloorName = data.name;
                this.getRoomNav(this.purifierForm.floorId,data=>{
                    this.roomNav = data.data.list;
                    this.purifierForm.roomId = '';
                    this.purifierFormRoomName = ''
                });
                this.purifierForm.roomId = '';
            },
            commandRoomPurifier(data){
                this.purifierForm.roomId = data.id;
                this.purifierFormRoomName = data.number;
            },
            lightsTkClose(){
                let this_ = this;
                this.lightsTkShow = false;
                setTimeout(function(){
                    this_.lightsTkShowbg = false;
                },400)
            },
            sensorTkClose(){
                let this_ = this;
                this.sensorTkShow = false;
                setTimeout(function(){
                    this_.sensorTkShowbg = false;
                },400)
            },
            purifierTkClose(){
                let this_ = this;
                this.purifierTkShow = false;
                setTimeout(function(){
                    this_.purifierTkShowbg = false;
                },400)
            },
            /*编辑设备*/
            editFun(type){
                if(type == '0' || type == '1'){
                    this.lightsTkShowbg = true;
                    this.lightsTkShow = true;
                    this.lightTkTitle = 'Edit light';
                    this.getLightInfo(this.lightId,obj=>{
                        for(let key in this.lightsForm){
                            this.lightsForm[key] = obj[key];
                            console.log(key,obj[key])
                        }
                        this.getFloorNav(data=>{
                            this.floorNav = data.data.list;
                            for(let d of this.floorNav){
                                if(d.id == obj.floorId){
                                    this.lightsFormFloorName = d.name;
                                }
                            }
                        })
                        this.getRoomNav(this.lightsForm.floorId,data=>{
                            this.roomNav = data.data.list;
                            for(let d of this.roomNav){
                                if(d.id == obj.roomId){
                                    this.lightsFormRoomName = d.number;
                                }
                            }
                        });
                    });
                }
                if(type == '2'){
                    this.sensorTkShowbg = true;
                    this.sensorTkShow = true;
                    this.sensorTkTitle = 'Edit sensor';
                    this.getSensorInfo(this.sensorId,obj=>{
                        for(let key in this.sensorForm){
                            this.sensorForm[key] = obj[key];
                        }
                        this.getFloorNav(data=>{
                            this.floorNav = data.data.list;
                            for(let d of this.floorNav){
                                if(d.id == obj.floorId){
                                    this.sensorFormFloorName = d.name;
                                }
                            }
                        })
                        this.getRoomNav(this.sensorForm.floorId,data=>{
                            this.roomNav = data.data.list;
                            for(let d of this.roomNav){
                                if(d.id == obj.roomId){
                                    this.sensorFormRoomName = d.number;
                                }
                            }
                        });
                    });
                }
                if(type == '3'){
                    this.purifierTkShowbg = true;
                    this.purifierTkShow = true;
                    this.purifierTkTitle = 'Edit purifier';
                    this.getPurifierInfo(this.purifierId,obj=>{
                        for(let key in this.purifierForm){
                            this.purifierForm[key] = obj[key];
                        }
                        this.getFloorNav(data=>{
                            this.floorNav = data.data.list;
                            for(let d of this.floorNav){
                                if(d.id == obj.floorId){
                                    this.purifierFormFloorName = d.name;
                                }
                            }
                        })
                        this.getRoomNav(this.purifierForm.floorId,data=>{
                            this.roomNav = data.data.list;
                            for(let d of this.roomNav){
                                if(d.id == obj.roomId){
                                    this.purifierFormRoomName = d.number;
                                }
                            }
                        });
                    });
                    this.get_mode_and_time(this.purifierId,data=>{
                        for(let key in data.data){
                            this.purifierFormNew[key] = data.data[key];
                        }
                    })
                }
                this.$nextTick(function(){
                    this.lightsTkShow = true;
                })
            },
            postSaveLight(type){
                let this_ = this;
                if(type == '0'||type == '1'){
                    base.ajax_post(
                        allUrl.roomLight.saveLight,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            lightId:this.lightId,
                            type:type,
                            ...this.lightsForm
                        },
                        {},
                        data=>{
                            this.getLightInfo(this.lightId)
                            this.getlightList();
                            this.lightsTkShow = false;
                            setTimeout(function(){
                                this_.lightsTkShowbg = false;
                            },400)
                            this.$message({
                              showClose: true,
                              message: data.msg,
                              type: 'success'
                            });
                        },
                        this
                    )
                }
                if(type == '2'){
                    base.ajax_post(
                        allUrl.roomLight.saveSensor,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            sensorId:this.sensorId,
                            type:'0',
                            ...this.sensorForm
                        },
                        {},
                        data=>{
                            this.getSensorInfo(this.sensorId)
                            this.getSensorList();
                            this.sensorTkShow = false;
                            setTimeout(function(){
                                this_.sensorTkShowbg = false;
                            },400)
                            this.$message({
                              showClose: true,
                              message: data.msg,
                              type: 'success'
                            });
                        },
                        this
                    )
                }
                if(type == '3'){
                    base.ajax_post(
                        allUrl.roomLight.savePurifier,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            purifierId:this.purifierId,
                            type:'0',
                            ...this.purifierForm
                        },
                        {},
                        data=>{
                            this.getPurifierInfo(this.purifierId)
                            this.get_mode_and_time(this.purifierId,data=>{
                                for(let key in data.data){
                                    this.purifierFormNew[key] = data.data[key];
                                }
                            })
                            this.getPurifierList();
                            this.purifierTkShow = false;
                            setTimeout(function(){
                                this_.purifierTkShowbg = false;
                            },400)
                            this.$message({
                              showClose: true,
                              message: data.msg,
                              type: 'success'
                            });
                        },
                        this
                    )
                }
            },

            commandHide(val){
                this.$nextTick(function(){
                    if($('.'+val)&&$('.'+val+' >.select').offset()){
                        $('.'+val).animate({scrollTop: $('.'+val).scrollTop() + $('.'+val+' >.select').offset().top - $('.'+val).offset().top - 100})
                    }
                })
            },
            dataColorTimeInput(val){
                if(Number(this.dataColorTime1)*60+Number(this.dataColorTime2)>=Number(this.dataColorTime3)*60+Number(this.dataColorTime4)){
                    if(val == '1'){
                        this.dataColorTime1 = this.dataColorTime3;
                    }else if(val == '3'){
                        this.dataColorTime3 = this.dataColorTime1;
                    }else if(val == '2'){
                        this.dataColorTime2 = this.dataColorTime4;
                    }else{
                        this.dataColorTime4 = this.dataColorTime2;
                    }
                    return
                }
                // console.log(val,Number(this.dataColorTime1)*60+Number(this.dataColorTime2),Number(this.dataColorTime3)*60+Number(this.dataColorTime4))
            },
            getHotelForecast(id){
                this.loading.getHotelForecast = true;
                base.ajax_post(
                    allUrl.roomLight.getHotelForecast,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        hotelId:id,
                    },
                    {},
                    data=>{
                        this.loading.getHotelForecast = false;
                        this.dataColorTime1 = data.data.sr?data.data.sr.split(':')[0]:0;
                        this.dataColorTime2 = data.data.sr?data.data.sr.split(':')[1]:0;
                        this.dataColorTime3 = data.data.ss?data.data.ss.split(':')[0]:0;
                        this.dataColorTime4 = data.data.ss?data.data.ss.split(':')[1]:0;
                        // base.ajax_post(
                        //     allUrl.roomLight.getHotelEditforecast,
                        //     {
                        //         username:this.username,
                        //         client_key:this.client_key,
                        //         token:this.token,
                        //         deviceId:this.lightId,
                        //         Sunrise:this.dataColorTime1+':'+this.dataColorTime2,
                        //         Sunset:this.dataColorTime3+':'+this.dataColorTime4,
                        //     },
                        //     {},
                        //     data=>{
                        //         this.$message({
                        //           showClose: true,
                        //           message: data.msg,
                        //           type: 'success'
                        //         });
                        //     },
                        //     this,
                        // )
                    },
                    this,()=>{
                        this.loading.getHotelForecast = false;
                    }
                )
            },
            dataColorTimeChange(val){
                let this_ = this;
                if(this.dataColorTimeChangetime){
                    clearTimeout(this.dataColorTimeChangetime)
                }
                this.dataColorTimeChangetime = setTimeout(function(){
                    if(this_['dataColorTime'+val]<10){
                        this_['dataColorTime'+val] = '0'+parseInt(this_['dataColorTime'+val])
                    }
                },300)
            },
            sunriseSunsetTypeFun(val){
                if(this.loading.roomLightBoottomNavFun){
                    return
                }
                this.loading.roomLightBoottomNavFun = true;
                base.ajax_postWs(
                    allUrl.roomLight.getHotelPattern,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        roomId:this.roomId,
                        pattern:val,
                        clientId:this.clientId,
                    },
                    this
                )
            },
            roomLightBoottomNavFun(val){
                if(!this.clientId){
                    return
                }
                this.roomLightBoottomNavVal = val;
                if(val == '1'){
                    if(this.roomLightBoottomNavVal1){
                        this.roomLightBoottomNavVal1 = false;
                        this.sunriseSunsetTypeFun('2')
                    }else{
                        this.roomLightBoottomNavVal1 = true;
                        this.sunriseSunsetTypeFun('1')
                    }
                }
                if(val == '2' && this.roomLightBoottomNavVal1){
                    if(this.roomLightBoottomNavVal2){
                        this.roomLightBoottomNavVal2 = false;
                        this.sunriseSunsetTypeFun('6')
                    }else{
                        this.roomLightBoottomNavVal2 = true;
                        this.sunriseSunsetTypeFun('3')
                    }
                }
                if(val == '3' && this.roomLightBoottomNavVal1){
                    if(this.roomLightBoottomNavVal3){
                        this.roomLightBoottomNavVal3 = false;
                        this.sunriseSunsetTypeFun('6')
                    }else{
                        this.roomLightBoottomNavVal3 = true;
                        this.sunriseSunsetTypeFun('4')
                    }
                }
                if(val == '4' && this.roomLightBoottomNavVal1){
                    if(this.roomLightBoottomNavVal4){
                        this.roomLightBoottomNavVal4 = false;
                        this.sunriseSunsetTypeFun('6')
                    }else{
                        this.roomLightBoottomNavVal4 = true;
                        this.sunriseSunsetTypeFun('5')
                    }
                }
                if(val == '5'){
                    if(this.roomLightBoottomNavVal5){
                        this.roomLightBoottomNavVal5 = false;
                    }else{
                        this.roomLightBoottomNavVal5 = true;
                        this.roomLightBoottomNavVal2 = false;
                        this.cirdadianLights = false;
                    }
                    this.$nextTick(function(){
                        let isSave = false;
                        if(this.bottomDemoTime1*60+this.bottomDemoTime2>(this.bottomDemoTime3-4)*60+this.bottomDemoTime4){
                            this.$message.error(this.$t('App.message.text37'));
                        }else{
                            isSave = true
                        }
                        this.bottomDemoTime4 = val
                        $('.room-light .room-light_bottom .room-light_bottom_flex .li .li_box .bed_time .time_warp .time2_box').scrollTop(this.bottomDemoTime4*this.remRatio*2)
                        if(isSave){
                            this.sleepOpen(()=>{},()=>{
                                if(this.roomLightBoottomNavVal5){
                                    this.roomLightBoottomNavVal5 = false;
                                }else{
                                    this.roomLightBoottomNavVal5 = true;
                                }
                            })
                        }
                    })
                }
            },
            cirdadianLightsFun(){
                if(this.cirdadianLights){
                    this.cirdadianLights = false;
                    this.sunriseSunsetTypeFun('0')
                }else{
                    // this.roomLightBoottomNavVal2 = false;
                    this.cirdadianLights = true;
                    this.roomLightBoottomNavVal2 = false;
                    this.roomLightBoottomNavVal3 = false;
                    this.roomLightBoottomNavVal4 = false;
                    this.roomLightBoottomNavVal5 = false;
                    this.sunriseSunsetTypeFun('7')
                }
            },
            sleepOpen(callback,error){
                if(this.timeoutSleep){
                    clearTimeout(this.timeoutSleep)
                    this.timeoutSleep = null;
                }
                this.timeoutSleep = setTimeout(()=>{
                    base.ajax_post(
                        allUrl.roomLight.sleepOpen,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            setting:this.roomLightBoottomNavVal5?'1':'0',
                            roomId:this.roomId,
                            wakeupTime:(this.bottomDemoTime1<10?'0'+Number(this.bottomDemoTime1):this.bottomDemoTime1)+':'+(this.bottomDemoTime2<10?'0'+Number(this.bottomDemoTime2):this.bottomDemoTime2),
                            sleepTime:((this.bottomDemoTime3-3)<10?'0'+Number(this.bottomDemoTime3-3):this.bottomDemoTime3-3)+':'+(this.bottomDemoTime4<10?'0'+Number(this.bottomDemoTime4):this.bottomDemoTime4),
                        },
                        {},
                        data=>{
                            this.newTime();
                            this.newTimeData.wakeupTime = this.bottomDemoTime1_+':'+this.bottomDemoTime2_;
                            if(callback){
                                callback()   
                            }
                            this.$message({
                              showClose: true,
                              message: data.msg,
                              type: 'success'
                            });
                        },
                        this,()=>{
                            if(error){
                                error()
                            }
                        }
                    )
                },3000)
            },
            colorChange(isTrue,valueR,valueG,valueB){
                if(isTrue){
                    this.colorR_ = valueR;
                    this.colorB_ = valueG;
                    this.colorG_ = valueB;
                    console.log(valueR,valueG,valueB)
                }else{
                    this.lampCmdData.colorR = valueR;
                    this.lampCmdData.colorG = valueG;
                    this.lampCmdData.colorB = valueB;
                    this.postLampColorRgb(this.lampCmdData,this.lightId,this.deviceId=='-1'?'all':null)
                }
            },
            colorValueChange(valueR,valueG,valueB){
                console.log('-------s----------')
                this.lampCmdData.colorR = valueR;
                this.lampCmdData.colorG = valueG;
                this.lampCmdData.colorB = valueB;
            },
            /*空气净化开关*/
            plSwitchPurifierFun(data,type){
                let this_ = this;
                if(type == 'all'&&this.deviceId == '-1'){
                    let i = 0;
                    if(data.status == 0){
                        data.status = 1;
                    }else{
                        data.status = 0
                    }
                    let time = setInterval(function(){
                        let isTrue = true;
                        if(data.status == this_.deviceList[i].status){
                            isTrue = false
                        }
                        if(isTrue){
                            this_.plSwitchPurifierFun(this_.deviceList[i],this_.deviceList[i].id)
                        }
                        i++
                        if(i == this_.deviceList.length){
                            clearInterval(time)
                        }
                    },100)
                    return
                }
                if(!this.trunOffDeviceLoading){
                    let isTrue = false;
                    if(data.model == '4'||data.model == '5'||data.model == '6'){
                        isTrue = true;
                    }else{
                        if(data.online == 0){
                            this.$notify({
                                message: 'Device not online',
                                type: 'warning'
                            });
                        }else if(data.blueStatus==0){
                            this.$notify({
                                message: 'Device not bound to gateway',
                                type: 'warning'
                            });
                        }else{
                            isTrue = true;
                        }
                    }
                    if(isTrue){
                        if(this.deviceId != '-1'){
                            if(data.status == 0){
                                data.status = 1;
                            }else{
                                data.status = 0
                            }
                        }
                        data.status_ = data.status;
                        data.level_ = data.level;
                        this.trunOffDeviceLoading = true;
                        this.trunOffDeviceLoadingIndex++;
                        base.ajax_postWs(
                            allUrl.roomLight.trunOffDevice,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                purifierId:this.purifierId,
                                status:data.status,
                                level:data.level,
                                clientId:this.clientId,
                            },
                            this
                        )
                    }
                }
            },
            levelCommand(arr){
                let level = arr[0];
                let purifierId = arr[1].id;
                let data = arr[1].data;
                let type = arr [2];
                let this_ = this;
                if(type == 'all'&&this.deviceId == '-1'){
                    let i = 0;
                    let time = setInterval(function(){
                        this_.levelCommand([level,{id:this_.deviceList[i].id,data:this_.deviceList[i]}])
                        i++
                        if(i == this_.deviceList.length){
                            clearInterval(time)
                        }
                    },100)
                    return
                }
                console.log(data)
                if(!this.trunOffDeviceLoading){
                    let isTrue = false;
                    if(data.model == '4'||data.model == '5'||data.model == '6'){
                        isTrue = true;
                    }else{
                        if(data.online == 0){
                            this.$notify({
                                message: 'Device not online',
                                type: 'warning'
                            });
                        }else if(data.blueStatus==0){
                            this.$notify({
                                message: 'Device not bound to gateway',
                                type: 'warning'
                            });
                        }else{
                          isTrue = true;  
                        }
                    }
                    if(isTrue){
                        if(data.level != level){
                            data.status_ = data.status;
                            data.level_ = data.level;

                            data.level = level;
                            this.trunOffDeviceLoading = true;
                            base.ajax_postWs(
                                allUrl.roomLight.trunOffDevice,
                                {
                                    username:this.username,
                                    client_key:this.client_key,
                                    token:this.token,
                                    purifierId:purifierId,
                                    status:data.status,
                                    level:level,
                                    clientId:this.clientId,
                                },
                                this
                            )
                        }
                    }
                }
            },
            /*设备灯光开关*/
            plSwitBrightnesschFun(data,lightId,type){
                let this_ = this;
                if(type == 'all'){
                    if(this.deviceId == '-1'){
                        let i = 0;
                        if(data.status == 0){
                            data.status = 1;
                        }else{
                            data.status = 0
                        }
                        let time = setInterval(function(){
                            let isTrue = true;
                            if(data.status == this_.deviceList[i].status){
                                isTrue = false
                            }
                            if(isTrue){
                                this_.plSwitBrightnesschFun(this_.deviceList[i],this_.deviceList[i].id)
                            }
                            i++
                            if(i == this_.deviceList.length){
                                clearInterval(time)
                            }
                        },100)
                        return
                    }
                }
                if(!data.loading_0){
                    let isTrue = false;
                    if(data.model == '4'||data.model == '5'||data.model == '6'){
                        isTrue = true;
                    }else{
                        if(data.online == 0){
                            this.$notify({
                                message: 'Device not online',
                                type: 'warning'
                            });
                        }else if(data.blueStatus==0){
                            this.$notify({
                                message: 'Device not bound to gateway',
                                type: 'warning'
                            });
                        }else{
                            isTrue =true;
                        }
                    }
                    if(isTrue){
                        data.loading_0 = true;
                        // console.log(data.id,data.status,data.status_)
                        if(data.status == 0){
                            data.status_ = 0
                            data.status = 1;
                        }else{
                            data.status_ = 1
                            data.status = 0
                        }
                        // console.log(data.id,data.status,data.status_)
                        base.ajax_postWs(
                            allUrl.roomLight.lampTurn,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                lightId:lightId,
                                status:data.status,
                                clientId:this.clientId,
                            },
                            this
                        )
                    }
                }
            },
            /**/
            lightStyleFun(val){
                if(this.lampCmdData.style == val){
                    this.lampCmdData.style = null;
                }else{
                    this.lampCmdData.style = val;
                }
                if(!this.loading.lightStyleFun){
                    this.loading.lightStyleFun = true;
                    base.ajax_post(
                        allUrl.roomLight.lightStyle,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            hotelId:this.hotelId,
                            deviceId:this.lightId,
                            style:val,
                        },
                        {},
                        data=>{
                            this.$message({
                                showClose: true,
                                message: data.msg,
                                type: 'success'
                            });
                            this.loading.lightStyleFun = false;
                        },
                        this,()=>{
                            this.loading.lightStyleFun = false;
                        }
                    )
                }
            },
            /*设备单独调光*/
            postLampLight(urlType,lightId,type,data){
                let url = '';
                if(urlType == '1'){
                    url = allUrl.roomLight.lampLightAsy;
                    if(this.lampCmdData.light == this.lampCmdDataLight){
                        return
                    }
                }else{
                    url = allUrl.roomLight.lampLightAsy;
                }
                let this_ = this;
                console.log(this.deviceId,lightId,type,'-------')
                if(type== 'all'){
                    if(this.deviceId == '-1'){
                        let i = 0;
                        let time = setInterval(function(){
                            this_.postLampLight(urlType,this_.deviceList[i].id,null,this_.deviceList[i])
                            i++
                            if(i == this_.deviceList.length){
                                clearInterval(time)
                            }
                        },100)
                        return
                    }
                }
                if(!data.loading_0){
                    let isTrue = false;
                    if(data.model == '4'||data.model == '5'||data.model == '6'){
                        isTrue = true;
                    }else{
                        if(data.online == 0){
                            this.$notify({
                                message: 'Device not online',
                                type: 'warning'
                            });
                            if(this.deviceId != '-1'){
                                this.lampCmdDataLight = this.lampCmdDataLight_
                            }
                        }else if(data.blueStatus==0){
                            this.$notify({
                                message: 'Device not bound to gateway',
                                type: 'warning'
                            });
                            if(this.deviceId != '-1'){
                                this.lampCmdDataLight = this.lampCmdDataLight_
                            }
                        }else{
                           isTrue = true; 
                        }
                    }
                    if(isTrue){
                        if(this.lampCmdData.light != this.lampCmdDataLight){
                            this.$set(data,'loading_0',true);
                            base.ajax_postWs(
                                url,
                                {
                                    username:this.username,
                                    client_key:this.client_key,
                                    token:this.token,
                                    lightId:lightId,
                                    light:parseInt(this.lampCmdDataLight),
                                    clientId:this.clientId,
                                },
                                this
                            )
                        }
                    }
                }
            },
            lampCmdDataLightChange(type){
                if(type == '-'&&this.lampCmdDataLight>0){
                    this.lampCmdDataLight--;
                }
                if(type == '+'&&this.lampCmdDataLight<100){
                    this.lampCmdDataLight++;
                }
                

                let this_ = this;
                clearTimeout(this.postLampLightTime)
                this.postLampLightTime = setTimeout(function(){
                    this_.postLampLight('2',this_.lightId,this_.deviceId == '-1'?'all':null,this_.lampCmdData)
                },300)
            },
            formatTooltip(val){
                return this.circadianColorArr[val];
            },
            /*设备单独调色温*/
            postLampColor(urlType){
                let url = '';
                let color = '';
                if(urlType == '1'){
                    url = allUrl.roomLight.lampColorAsy
                    color = parseInt(this.lampCmdDataColor)
                }else{
                    url = allUrl.roomLight.lampColorAsy
                    color = parseInt(this.circadianColorArr[this.lampCmdDataColor_circadian])
                }
                console.log(this.lampCmdData)
                if(!this.loading.lampColor){
                    let isTrue = false;
                    if(this.lampCmdData.model == '4'||this.lampCmdData.model == '5'||this.lampCmdData.model == '6'){
                        isTrue = true;
                    }else{
                        if(this.lampCmdData.online == 0){
                            this.$notify({
                                message: 'Device not online',
                                type: 'warning'
                            });
                            if(urlType == '1'){
                                this.lampCmdDataColor = this.lampCmdDataColor_
                            }else{
                                this.lampCmdDataColor_circadian = this.lampCmdDataColor_circadian_
                            }
                        }else if(this.lampCmdData.blueStatus==0){
                            this.$notify({
                                message: 'Device not bound to gateway',
                                type: 'warning'
                            });
                            if(urlType == '1'){
                                this.lampCmdDataColor = this.lampCmdDataColor_
                            }else{
                                this.lampCmdDataColor_circadian = this.lampCmdDataColor_circadian_
                            }
                        }else{
                            isTrue = true;
                        }
                    }
                    if(isTrue){
                        if(this.lampCmdData.color != color){
                            this.loading.lampColor = true;

                            base.ajax_postWs(
                                url,
                                {
                                    username:this.username,
                                    client_key:this.client_key,
                                    token:this.token,
                                    lightId:this.lightId,
                                    color:color,
                                    clientId:this.clientId,
                                },
                                this
                            )
                        }
                    }
                }
            },
            lampCmdDataColorChange(type){
                if(!this.cirdadianLights){
                    return
                }
                if(type == '-'&&this.lampCmdDataColor_circadian>0){
                    this.lampCmdDataColor_circadian--;
                    let this_ = this;
                    clearTimeout(this.postLampColorTime)
                    this.postLampColorTime = setTimeout(function(){
                        this_.postLampColor('2')
                    },1000)
                }
                if(type == '+'&&this.lampCmdDataColor_circadian<15){
                    this.lampCmdDataColor_circadian++;
                    let this_ = this;
                    clearTimeout(this.postLampColorTime)
                    this.postLampColorTime = setTimeout(function(){
                        this_.postLampColor('2')
                    },1000)
                }
            },
            /*设备单独调颜色*/
            postLampColorRgb(data,lightId,type){
                let this_ = this;
                if(this.deviceId == '-1'&&type== 'all'){
                    let i = 0;
                    let time = setInterval(function(){
                        this_.postLampColorRgb(this_.deviceList[i],this_.deviceList[i].id)
                        i++;
                        if(i == this_.deviceList.length){
                            clearInterval(time)
                        }
                    },100)
                    return
                }
                if(!this.loading.lampColorRgb){
                    let isTrue = false;
                    if(data.model == '4'||data.model == '5'||data.model == '6'){
                        isTrue = true;
                    }else{
                        if(data.online == 0){
                            this.$notify({
                                message: 'Device not online',
                                type: 'warning'
                            });
                            // dataColor = dataColor_
                        }else if(data.blueStatus==0){
                            this.$notify({
                                message: 'Device not bound to gateway',
                                type: 'warning'
                            });
                            // dataColor = dataColor_
                        }else{
                            isTrue = true;
                        }
                    }
                    if(isTrue){
                        this.lampColorRgbIndex++;
                        this.loading.lampColorRgb = true;
                        base.ajax_postWs(
                            allUrl.roomLight.lampColorRgb,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                lightId:lightId,
                                colorR:data.colorR,
                                colorG:data.colorG,
                                colorB:data.colorB,
                                clientId:this.clientId,
                            },
                            this
                        )
                    }
                }
            },
            /*灯设备列表*/
            getlightList(deviceType,callback){
                this.loading.deviceList = true;
                base.ajax_post(
                    allUrl.roomLight.lightList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                        roomId:this.roomId,
                        page:1,
                        count:100,
                        type:this.deviceType,
                        keywords:this.keywords,
                    },
                    {},
                    data=>{
                        this.loading.deviceList = false;
                        this.deviceList = data.data.list;
                        for(let d of this.deviceList){
                            this.$set(d,'status_',d.status)
                            this.$set(d,'loading_0',false)
                        }
                        if(callback){
                            callback(data)
                        }
                    },
                    this,()=>{
                        this.loading.deviceList = false;
                    }
                )
            },
            /*灯设备详情*/
            getLightInfo(lightId,callback){
                let this_ = this;
                base.ajax_post(
                    allUrl.roomLight.lightInfo,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        lightId:lightId,
                    },
                    {},
                    data=>{
                        this.lampCmdData = data.data;
                        this.lampCmdDataLight = this.lampCmdData.light;
                        this.lampCmdDataLight_ = this.lampCmdData.light;
                        if(this.deviceType == '1'){
                            this.lampCmdDataColor_circadian = this.circadianColorArr.indexOf(this.lampCmdData.color)>0?this.circadianColorArr.indexOf(this.lampCmdData.color):0;
                            this.lampCmdDataColor_circadian_ = this.circadianColorArr.indexOf(this.lampCmdData.color)>0?this.circadianColorArr.indexOf(this.lampCmdData.color):0;
                        }
                        this.lampCmdDataColor = this.lampCmdData.color;
                        this.lampCmdDataColor_ = this.lampCmdData.color;
                        this.colorValue = 'rgb('+this.lampCmdData.colorR+','+this.lampCmdData.colorG+','+this.lampCmdData.colorB+')';

                        this.cirLightsPlanId = this.lampCmdData.plan
                        console.log(this.lampCmdData.plan)
                        let time = setInterval(function(){
                            if(this_.$refs.colorPicker){
                                this_.$refs.colorPicker.setColorValue(this_.colorValue);
                                clearInterval(time)
                            }
                        },100)
                        this.$nextTick(function(){
                            if(this.myChart1){
                                this.myChart1.resize();
                            }
                            if(this.myChart2){
                                this.myChart2.resize();
                            }
                        })
                        if(callback){
                            callback(data.data)
                        }
                    },
                    this
                )
            },
            /*传感器设备列表*/
            getSensorList(callback){
                this.loading.deviceList = true;
                base.ajax_post(
                    allUrl.roomLight.sensorList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                        roomId:this.roomId,
                        page:1,
                        count:100,
                        keywords:this.keywords,
                    },
                    {},
                    data=>{
                        this.loading.deviceList = false;
                        this.deviceList = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this,()=>{
                        this.loading.deviceList = false;
                    }
                )
            },
            /*传感器设备详情*/
            getSensorInfo(sensorId,callback){
                base.ajax_post(
                    allUrl.roomLight.sensorInfo,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        sensorId:sensorId,
                    },
                    {},
                    data=>{
                        this.sensorInfoData = data.data;
                        if(callback){
                            callback(data.data)
                        }
                    },
                    this
                )
            },
            /*传感器数据更新*/
            updateSensorInfo(){
                if(!this.loading.updateSensorInfo){

                    this.loading.updateSensorInfo = true;
                    base.ajax_post(
                        allUrl.roomLight.updateSensorInfo,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            sensorId:this.sensorId,
                        },
                        {},
                        data=>{
                            this.$message({
                                showClose: true,
                                message: data.msg,
                                type: 'success'
                            });
                            this.getSensorInfo(this.sensorId)
                            this.loading.updateSensorInfo = false;
                        },
                        this,
                        ()=>{
                            this.loading.updateSensorInfo = false;
                        }
                    )
                }
            },
            /*传感器历史记录*/
            getSensorHistory(timeType,callback){
                let arr = [0,2,3,4,1];
                timeType = arr[timeType];
                base.ajax_post(
                    allUrl.roomLight.sensorHistory,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        deviceId:this.sensorId,
                        dateType:timeType,
                    },
                    {},
                    data=>{
                        console.log(data)
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )

            },
            /*空气净化器设备列表*/
            getPurifierList(callback){
                this.loading.deviceList = true;
                base.ajax_post(
                    allUrl.roomLight.purifierList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                        roomId:this.roomId,
                        page:1,
                        count:100,
                        keywords:this.keywords,
                    },
                    {},
                    data=>{
                        this.loading.deviceList = false;
                        this.deviceList = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this,()=>{
                        this.loading.deviceList = false;
                    }
                )
            },
            /*空气净化器设备详情*/
            getPurifierInfo(purifierId,callback){
                base.ajax_post(
                    allUrl.roomLight.purifierInfo,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        purifierId:purifierId,
                    },
                    {},
                    data=>{
                        this.purifierInfoData = data.data;
                        this.purifierInfoData.status = Number(this.purifierInfoData.status);
                        this.purifierInfoData.status_ = this.purifierInfoData.status;
                        this.purifierInfoData.level_ = this.purifierInfoData.level;
                        // this.purifierInfoData.online = 1;
                        if(callback){
                            callback(data.data)
                        }
                    },
                    this
                )
            },
            /*灯设备日志信息*/
            getLampReport(dataType,timeType,callback,isTk){
                base.ajax_post(
                    allUrl.roomLight.lampReport,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        lightId:this.lightId,
                        type:timeType,
                        dataType:dataType,
                    },
                    {},
                    data=>{
                        if(!isTk){
                            this.lampReport = data.data;
                        }
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*空气净化器设备日志信息*/
            getPurifierReport(timeType,callback){
                base.ajax_post(
                    allUrl.roomLight.purifierReport,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        purifierId:this.purifierId,
                        dateType:timeType,
                    },
                    {},
                    data=>{
                        this.purifierReport = data.data;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            deviceSelectFun(data){
                let this_ = this;
                if(this.deviceId == '-1' && data.id == '-1'){
                    console.log(this.deviceId_,this.deviceId)
                    this.deviceSelectFun({id:this.deviceId_})
                    // lampCmdData
                }else{
                    this.deviceId = data.id;
                    if(data.id == '-1'){
                        this.deviceInfoType = '1';
                        if(this.deviceType == '0' || this.deviceType == '1'){
                            this.lampCmdData = {
                                name:'',
                                deviceId:'',
                                model:2,
                                light:0,
                                status:0,
                                online:null,
                                blueStatus:null,
                                alarmStatus:0,
                                color:0,
                                colorR:0,
                                colorG:0,
                                colorB:0,
                            };
                            if(this.deviceType == '0'){
                                for(let d of this.deviceList){
                                    if(d.model < this.lampCmdData.model){
                                        this.lampCmdData.model = d.model;
                                    }
                                }
                            }
                            this.lampCmdDataLight = this.lampCmdData.light;
                            this.lampCmdDataLight_ = this.lampCmdData.light;
                            if(this.deviceType == '1'){
                                this.lampCmdDataColor_circadian = this.circadianColorArr.indexOf(this.lampCmdData.color)>0?this.circadianColorArr.indexOf(this.lampCmdData.color):0;
                                this.lampCmdDataColor_circadian_ = this.circadianColorArr.indexOf(this.lampCmdData.color)>0?this.circadianColorArr.indexOf(this.lampCmdData.color):0;
                            }
                            this.lampCmdDataColor = this.lampCmdData.color;
                            this.lampCmdDataColor_ = this.lampCmdData.color;
                            this.colorValue = 'rgb('+this.lampCmdData.colorR+','+this.lampCmdData.colorG+','+this.lampCmdData.colorB+')';

                            let time = setInterval(function(){
                                if(this_.$refs.colorPicker){
                                    this_.$refs.colorPicker.setColorValue(this_.colorValue);
                                    clearInterval(time)
                                }
                            },100)
                            this.getEnergyConsumption(this.lightId,this.deviceType == '0'?this.timeType1:this.timeType2);
                        }
                    }else{
                        this.deviceId_ = data.id;
                        if(this.deviceType == '0' || this.deviceType == '1'){
                            this.lightId = data.id;
                            this.getLightInfo(data.id,()=>{
                                this.getEnergyConsumption(this.lightId,this.deviceType == '0'?this.timeType1:this.timeType2);
                            });
                        }
                        if(this.deviceType == '2'){
                            this.getSensorInfo(data.id)
                        }
                        if(this.deviceType == '3'){
                            this.purifierId = data.id;
                            this.getPurifierInfo(data.id,()=>{{
                                this.getPurifierReport(this.timeType4,data=>{
                                    this.energyConsumption({dataList:data.data.workTimeList,timeList:data.data.timeList},'h')

                                })
                            }})
                            this.get_mode_and_time(this.purifierId,data=>{
                                for(let key in data.data){
                                    this.purifierFormNew[key] = data.data[key];
                                }
                            })
                        }
                    }
                }
            },
            deviceTypeFun(val){
                this.deviceType = val;
                var storage = window.localStorage;
                storage.setItem('deviceType',this.deviceType);
                if(val == '0' || val == '1'){
                    this.getlightList(this.deviceType,data=>{
                        if(data.data.list.length > 0){
                            this.deviceId = data.data.list[0].id;
                            this.deviceId_ = data.data.list[0].id;
                            this.lightId = data.data.list[0].id;
                            this.getLightInfo(data.data.list[0].id,()=>{
                                this.getEnergyConsumption(this.lightId,this.deviceType == '0'?this.timeType1:this.timeType2);
                            })
                        }else{
                            this.deviceId = '';
                            this.deviceId_ = '';
                            this.lightId = '';
                            this.deviceInfoType = '1';
                        }
                    });
                }
                if(val == '2'){
                    this.getSensorList(data=>{
                        if(data.data.list.length > 0){
                            this.deviceId = data.data.list[0].id;
                            this.deviceId_ = data.data.list[0].id;
                            this.sensorId = data.data.list[0].id;
                            this.getSensorInfo(data.data.list[0].id)
                        }else{
                            this.deviceId = '';
                            this.deviceId_ = '';
                            this.sensorId = '';
                            this.deviceInfoType = '1';
                        }
                    });
                }
                if(val == '3'){
                    this.getPurifierList(data=>{
                        if(data.data.list.length > 0){
                            this.deviceId = data.data.list[0].id;
                            this.deviceId_ = data.data.list[0].id;
                            this.purifierId = data.data.list[0].id;
                            this.getPurifierInfo(data.data.list[0].id,()=>{
                                this.getPurifierReport(this.timeType4,data=>{
                                    this.energyConsumption({dataList:data.data.workTimeList,timeList:data.data.timeList},'h')
                                })
                            })
                            this.get_mode_and_time(this.purifierId,data=>{
                                for(let key in data.data){
                                    this.purifierFormNew[key] = data.data[key];
                                }
                            })
                        }else{
                            this.deviceId = '';
                            this.deviceId_ = '';
                            this.purifierId = '';
                            this.deviceInfoType = '1';
                        }
                    });
                }
                // this.$nextTick(function(){
                //     this.getEnergyConsumption();
                // })
            },
            deviceInfoTypeFun(val){
                if(val == '1'){
                    this.deviceInfoTypeTitle1 = this.$t('App.room_light.text6');
                    this.deviceInfoTypeTitle2 = this.$t('App.room_light.text67');

                    this.$nextTick(function(){
                        if(this.deviceType == '0' || this.deviceType == '1'){
                            if(this.$refs.colorPicker){
                                this.$refs.colorPicker.setColorValue(this.colorValue);
                            }
                            this.getEnergyConsumption(this.lightId,this.deviceType == '0'?this.timeType1:this.timeType2);
                        }
                    })
                }
                if(val == '2'){
                    this.deviceInfoTypeTitle1 = this.$t('App.room_light.text68');
                    this.deviceInfoTypeTitle2 = this.$t('App.room_light.text69');
                }
                this.deviceInfoType = val
            },
            plSwitchFun(val){
                if(val == 0){
                    this.value = 1
                }else{
                    this.value = 0
                }
            },
            linkToFun(val){
                if(val == '/service'){
                    let disConnectTime = '';
                    if(this.lampCmdData.disConnectTime){
                       disConnectTime =  this.lampCmdData.disConnectTime.format("YYYY-mm-dd");
                    }
                    this.$router.push({path:val+'?floorId='+this.lampCmdData.floorId+'&roomId='+this.lampCmdData.roomId+'&deviceType='+this.deviceType+'&daysDate='+disConnectTime});
                }else{
                    this.$router.push({path:val});
                }
                this.$store.commit('ROUTERSTRFUN',{
                    routerStr:val,
                })
            },
            timeTypeCommand1(data){
                this.timeType1 = data.value;
                this.timeTypeStr1 = data.label;
                this.getEnergyConsumption(this.lightId,this.timeType1);
            },
            timeTypeCommand2(data){
                this.timeType2 = data.value;
                this.timeTypeStr2 = data.label;
                this.getEnergyConsumption(this.lightId,this.timeType2);
            },
            timeTypeCommand4(data){
                this.timeType4 = data.value;
                this.timeTypeStr4 = data.label;
                // this.getEnergyConsumption(this.lightId,this.timeType2);
                this.getPurifierReport(this.timeType4,data=>{
                    this.energyConsumption({dataList:data.data.workTimeList,timeList:data.data.timeList},'h')
                })
            },
            handleCommand(){

            },
            /*楼房下拉列表*/
            getbuildNav(callback){
                base.ajax_post(
                    allUrl.room.buildNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        hotelId:this.hotelId,
                    },
                    {},
                    data=>{
                        this.buildNav = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            historySee(){
                this.historyShowbg = true;
                this.$nextTick(function(){
                    this.historyShow = true;
                    if(this.deviceType == '0' || this.deviceType == '1'){
                        this.echartsName1 = 'Energy consumption';
                        this.echartsName2 = 'Lighting use schedule';
                        this.getEnergyConsumption(this.lightId,this.timeType3,data=>{
                            this.echartsFun(data,this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box1','kWh');
                        });
                        this.getLightingUseSchedule(this.lightId,this.timeType3,data=>{
                            this.echartsFun(data,this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box2','H');
                        });
                    }
                    if(this.deviceType == '2'){
                        this.echartsName1 = 'Temperature Statistics';
                        this.echartsName2 = 'Humidity Statistics';
                        this.echartsName3 = 'CO₂ Statistics';
                        this.echartsName4 = 'PM2.5 Statistics';
                        this.echartsName5 = 'PM10 Statistics';
                        this.echartsName6 = 'TVOC Statistics';
                        this.echartsName7 = 'HCHO Statistics';
                        this.getSensorHistory(this.timeType3,data=>{
                            this.echartsFun({dataList:data.data.temperature,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box1','℃');
                            this.echartsFun({dataList:data.data.humidity,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box2','RH%');
                            this.echartsFun({dataList:data.data.CO2,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box3','ppm');
                            this.echartsFun({dataList:data.data.PM25,timeList:data.data.updateTime},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box4','µg/m³');
                            this.echartsFun({dataList:data.data.PM10,timeList:data.data.updateTime},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box5','µg/m³');
                            this.echartsFun({dataList:data.data.formaldehyde,timeList:data.data.updateTime},this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box6','ppb');
                            this.echartsFun({dataList:data.data.VOC,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box7','lux');
                            // this.echartsFun({dataList:data.data.formaldehyde,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box5','dB');
                        })
                    }
                    if(this.deviceType == '3'){
                        this.echartsName1 = 'Working time of equipment';
                        this.echartsName2 = 'Working time of filter screen';
                        this.getPurifierReport(this.timeType3,data=>{
                            this.echartsFun({dataList:data.data.userTimeList,timeList:data.data.timeList},this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box1','h');
                            this.echartsFun({dataList:data.data.workTimeList,timeList:data.data.timeList},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box2','h');
                        })
                    }
                    // this.echartsFun({},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box3');
                })
            },
            chartTypeChange(){
                for(let d of this.chartTypeArr){
                    if(d.value == this.chartType){
                        this.chartTypeStr = d.str
                    }
                }
                if(this.deviceType == '0' || this.deviceType == '1'){
                    this.getEnergyConsumption(this.lightId,this.timeType3,data=>{
                        this.echartsFun(data,this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box1','kWh');
                    });
                    this.getLightingUseSchedule(this.lightId,this.timeType3,data=>{
                        this.echartsFun(data,this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box2','H');
                    });
                }
                if(this.deviceType == '2'){
                        // this.echartsName6 = 'Illuminance Statistics';
                    this.getSensorHistory(this.timeType3,data=>{
                        this.echartsFun({dataList:data.data.temperature,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box1','℃');
                        this.echartsFun({dataList:data.data.humidity,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box2','RH%');
                        this.echartsFun({dataList:data.data.CO2,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box3','ppm');
                        this.echartsFun({dataList:data.data.PM25,timeList:data.data.updateTime},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box4','µg/m³');
                        this.echartsFun({dataList:data.data.PM10,timeList:data.data.updateTime},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box5','µg/m³');
                        this.echartsFun({dataList:data.data.formaldehyde,timeList:data.data.updateTime},this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box6','ppb');
                        this.echartsFun({dataList:data.data.VOC,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box7','lux');
                    })
                }
                if(this.deviceType == '3'){
                    this.getPurifierReport(this.timeType3,data=>{
                        this.echartsFun({dataList:data.data.workTimeList,timeList:data.data.timeList},this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box1','h');
                        this.echartsFun({dataList:data.data.workTimeList,timeList:data.data.timeList},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box2','h');
                    })
                }
            },
            timeType2Change(){
                if(this.deviceType == '0' || this.deviceType == '1'){
                    this.getEnergyConsumption(this.lightId,this.timeType3,data=>{
                        this.echartsFun(data,this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box1','kWh');
                    });
                    this.getLightingUseSchedule(this.lightId,this.timeType3,data=>{
                        this.echartsFun(data,this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box2','H');
                    });
                }
                if(this.deviceType == '2'){
                        // this.echartsName6 = 'Illuminance Statistics';
                    this.getSensorHistory(this.timeType3,data=>{
                        this.echartsFun({dataList:data.data.temperature,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box1','℃');
                        this.echartsFun({dataList:data.data.humidity,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box2','RH%');
                        this.echartsFun({dataList:data.data.CO2,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box3','ppm');
                        this.echartsFun({dataList:data.data.PM25,timeList:data.data.updateTime},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box4','µg/m³');
                        this.echartsFun({dataList:data.data.PM10,timeList:data.data.updateTime},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box5','µg/m³');
                        this.echartsFun({dataList:data.data.formaldehyde,timeList:data.data.updateTime},this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box6','ppb');
                        this.echartsFun({dataList:data.data.VOC,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box7','lux');
                    })
                }
                if(this.deviceType == '3'){
                    this.getPurifierReport(this.timeType3,data=>{
                        this.echartsFun({dataList:data.data.workTimeList,timeList:data.data.timeList},this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box1','h');
                        this.echartsFun({dataList:data.data.workTimeList,timeList:data.data.timeList},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box2','h');
                    })
                }
                // this.echartsFun({},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box3');
            },
            historyClose(){
                let this_ = this;
                this.historyShow = false;
                setTimeout(function(){
                    this_.historyShowbg = false;
                },400)
            },
            getEnergyConsumption(lightId,timeType,callback){
                base.ajax_post(
                    allUrl.dashboard.energyConsumption,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        hotelId:this.hotelId,
                        devId:lightId,
                        dateType:timeType,
                        roomId:this.deviceId == '-1'?this.roomId:null,
                    },
                    {},
                    data=>{
                        if(callback){
                            callback(data.data)
                        }else{
                            this.energyConsumption(data.data,'kWh')
                        }
                    },
                    this
                )
            },
            getLightingUseSchedule(lightId,timeType,callback){
                base.ajax_post(
                    allUrl.dashboard.lightingUseSchedule,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        hotelId:this.hotelId,
                        devId:lightId,
                        dateType:timeType,
                    },
                    {},
                    data=>{
                        if(callback){
                            callback(data.data)
                        }else{
                            this.energyConsumption(data.data)
                        }
                    },
                    this
                )
            },
            energyConsumption(data,unit){
                // console.log(data)
                let this_ = this;
                let yMax = 0.01;
                let yMaxList = [];
                for(let val of data.dataList){
                    if(val > yMax){
                        yMax = val;
                    }
                    yMaxList.push(yMax)
                }
                for(let key in yMaxList){
                    yMaxList[key] = yMax
                }
                let gridLeft = (yMax+'-').length*10;
                if(yMax>1){
                    gridLeft = (parseInt(yMax)+'-').length*10;
                }
                console.log(yMax,gridLeft)
                this.$nextTick(function(){
                    if(document.getElementsByClassName('electricity_consumption_echarts')[0]){
                        this.myChart1 = this.$echarts.init(document.getElementsByClassName('electricity_consumption_echarts')[0]);
                        this.myChart1.setOption({
                            tooltip:{
                                trigger:'axis',
                                axisPointer:{
                                    type: 'shadow',
                                    snap:true,
                                },
                                padding:0,
                                formatter: function (params) {
                                    // console.log(params)
                                    var tls = `<div class="electricity_consumption_echarts_tooltip"><p class="p1"><i style="background-color:${params[1].color}"></i><span class="span1">${params[1].value}${unit}</span><span class="span1"></span></p><p class="p2">${params[1].name}</p></div>`;
                                   return tls;
                                },
                            },
                            grid:{
                                top:10,
                                left:gridLeft,
                                right:20,
                                bottom:30,
                            },
                            xAxis: {
                                type: 'category',
                                boundaryGap: true,
                                data: data.timeList,
                                axisTick:{
                                    show:false,
                                    alignWithLabel: true
                                },
                                axisLine:{
                                    show:false,
                                },
                                splitArea:{
                                    show:false,
                                },
                                axisLabel:{
                                    color:'rgba(101,112,133,1)',
                                    // fontStyle:'AlibabaPuHuiTiR',
                                    fontSize:14,
                                },
                            },
                            yAxis: {
                                // show:false,
                                type: 'value',
                                // nameGap:6,
                                splitNumber:3,
                                minInterval:0.01,
                                axisTick:{
                                    show:false,
                                },
                                axisLine:{
                                    show:false
                                },
                                minorTick:{
                                    show:false,
                                },
                                axisLabel:{
                                    color:'rgba(101,112,133,1)',
                                    // fontStyle:'AlibabaPuHuiTiR',
                                    fontSize:14,
                                },
                                splitLine:{
                                    show:false,
                                }
                            },
                            series: [
                                { // For shadow
                                    type: 'bar',
                                    itemStyle: {
                                        normal: {color: 'rgba(0,0,0,0.05)'}
                                    },
                                    barGap:'-100%',
                                    barCategoryGap:'40%',
                                    barWidth:'50%',
                                    data: yMaxList,
                                    animation: false
                                },
                                {
                                data: data.dataList,
                                type: 'bar',
                                barWidth:'50%',
                                areaStyle: {
                                    color:{
                                        type: 'linear',
                                        x: 0,
                                        y: 0,
                                        x2: 0,
                                        y2: 1,
                                        colorStops: [{
                                            offset: 0, color: this_.version=='1'?'#513C93':'#05CFAB' // 0% 处的颜色
                                        }, {
                                            offset: 1, color: '#ffffff' // 100% 处的颜色
                                        }],
                                        globalCoord: false // 缺省为 false
                                    }
                                },
                                lineStyle:{
                                    color:this_.version=='1'?'#513C93':'#05CFAB',
                                },
                                itemStyle:{
                                    color:this_.version=='1'?'#513C93':'#05CFAB',
                                }
                            }]
                        });
                        this.myChart1.resize();
                    }
                })
            },
            echartsFun(data,type,color,className,unit){
                console.log(data,className)
                this.myChart2 = this.$echarts.init(document.getElementsByClassName(className)[0]);
                this.myChart2.setOption({
                    tooltip:{
                        trigger:'axis',
                        axisPointer:{
                            type : type=='bar'?'shadow':'line',
                            snap:true,
                        },
                        padding:0,
                        formatter: function (params) {
                            // console.log(params)
                            var tls = `<div class="history_echarts_tooltip"><p class="p1"><i style="background-color:${params[0].color}"></i><span class="span1">${params[0].value}</span><span class="span1">${unit}</span></p><p class="p2">${params[0].name}</p></div>`;
                           return tls;
                        },
                    },
                    grid:{
                        top:10,
                        left:40,
                        right:50,
                        bottom:40,
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: type=='bar'?true:false,
                        data: data.timeList,
                        axisTick:{
                            show:false,
                            alignWithLabel: true
                        },
                        axisLine:{
                            show:false
                        },
                        axisLabel:{
                            color:'rgba(163,175,187,1)',
                            fontStyle:'AlibabaPuHuiTiR',
                            fontSize:'1rem',
                        },
                    },
                    yAxis: {
                        type: 'value',
                        nameGap:6,
                        splitNumber:4,
                        axisTick:{
                            show:false,
                        },
                        axisLine:{
                            show:false
                        },
                        splitLine:{
                            lineStyle:{
                                color:'rgba(235,239,242,1)'
                            }
                        },
                        axisLabel:{
                            color:'rgba(163,175,187,1)',
                            fontStyle:'AlibabaPuHuiTiR',
                            fontSize:'1rem',
                        },
                    },
                    series: [{
                        data: data.dataList,
                        type: type,
                        smooth:true,
                        barWidth:type=='bar'?'50%':null,
                        symbol:type=='line'?'none':false,
                        lineStyle:{
                            color:color,
                        },
                        itemStyle:{
                            color:color,
                        },
                        markLine:{
                            data:type=='line'?[{type:'average',name:'平均值'}]:null,
                            lineStyle:{
                                color:'rgba(5,206,171,0.4)',
                                type:'dotted',
                            }
                        }
                    }]
                });
            },
        },
        watch:{
            deviceType:function(){
                this.img_device_0 = require('../img/device_0_1.png');
                this.img_device_1 = require('../img/device_1_1.png');
                this.img_device_2 = require('../img/device_2_1.png');
                this.img_device_3 = require('../img/device_3_1.png');
                this['img_device_'+this.deviceType] = require('../img/device_'+this.deviceType+'_2.png');
                // this['img_device_'+this.deviceType] = require('../img/device_'+this.deviceType+'_2.png');
                if(this.version == 1){
                    this['img_device_'+this.deviceType] = require('../img/device_'+this.deviceType+'_2_v1.png');
                }
            },
            updateRemRatio:function(){
                this.$nextTick(function(){
                    if(this.myChart1){
                        this.myChart1.resize();
                    }
                    if(this.myChart2){
                        this.myChart2.resize();
                    }
                })
            },
            lampCmdDataLight:function(){
                if(this.deviceType == '1'){
                    if(this.lampCmdDataLight){
                        let lampCmdDataLight = '';
                        if(this.lampCmdDataLight<10){
                            lampCmdDataLight = '00'+this.lampCmdDataLight;
                        }else if(this.lampCmdDataLight < 100){
                            lampCmdDataLight = '0'+this.lampCmdDataLight;
                        }else{
                            lampCmdDataLight = this.lampCmdDataLight+'';
                        }
                        this.databrightnessInput0 = lampCmdDataLight.split('')[0];
                        this.databrightnessInput1 = lampCmdDataLight.split('')[1];
                        this.databrightnessInput2 = lampCmdDataLight.split('')[2];
                    }else{
                        this.databrightnessInput0 = 0;
                        this.databrightnessInput1 = 0;
                        this.databrightnessInput2 = 0;
                    }
                }
            },
            lampCmdDataColor_circadian:function(){
                let lampCmdDataColor = this.circadianColorArr[this.lampCmdDataColor_circadian]+'';
                // console.log(this.lampCmdDataColor_circadian,this.circadianColorArr[this.lampCmdDataColor_circadian]+'')
                if(lampCmdDataColor){
                    this.dataColorTempInput0 = lampCmdDataColor.split('')[0];
                    this.dataColorTempInput1 = lampCmdDataColor.split('')[1];
                    this.dataColorTempInput2 = lampCmdDataColor.split('')[2];
                    this.dataColorTempInput3 = lampCmdDataColor.split('')[3];

                    this.dataColorInput0 = lampCmdDataColor.split('')[0];
                    this.dataColorInput1 = lampCmdDataColor.split('')[1];
                    this.dataColorInput2 = lampCmdDataColor.split('')[2];
                    this.dataColorInput3 = lampCmdDataColor.split('')[3];
                }else{
                    this.dataColorTempInput0 = 0;
                    this.dataColorTempInput1 = 0;
                    this.dataColorTempInput2 = 0;
                    this.dataColorTempInput3 = 0;

                    this.dataColorInput0 = 0;
                    this.dataColorInput1 = 0;
                    this.dataColorInput2 = 0;
                    this.dataColorInput3 = 0;
                }
            },
            lightId:function(val){
                if(this.websocket3){
                    this.websocket3.close()
                }
                base.websocket(allUrl.websocket.ws,websocket=>{
                    this.websocket3 = websocket;
                    websocket.send('{"type":"devInfo","devId":'+val+'}');
                    websocket.onmessage = event => {
                        // console.log(JSON.parse(event.data));
                        if(this.deviceId != '-1'){
                            let data = JSON.parse(event.data)
                            this.lampCmdData.light = Number(data.light);
                            this.lampCmdDataLight = this.lampCmdData.light;
                            this.lampCmdDataLight_ = this.lampCmdData.light;

                            this.lampCmdData.color = Number(data.color);
                            if(this.deviceType == '1'){

                                this.lampCmdDataColor_circadian = this.circadianColorArr.indexOf(this.lampCmdData.color)>0?this.circadianColorArr.indexOf(this.lampCmdData.color):0;
                                this.lampCmdDataColor_circadian_ = this.circadianColorArr.indexOf(this.lampCmdData.color)>0?this.circadianColorArr.indexOf(this.lampCmdData.color):0;
                            }
                            this.lampCmdDataColor = this.lampCmdData.color;
                            this.lampCmdDataColor_ = this.lampCmdData.color;
                        }
                        
                    }
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
    .room-light{
        margin-top: 0.2rem;
        position: relative;
        min-height: 62rem;
        height: calc(100% - 0.2rem);
        // background-image: url('../img/Room-light_bg.png');
        background-image: url('../img/room/room_bg_.jpg');
        background-size: 100% 100%;
        background-position: center center;
        &.cn{
            .room-light_left{
                .flex_ul2{
                    .btn{
                        &.select{
                            background-color: #513C93;
                        }
                    }
                    .flex_li{
                        .img_box{
                            .pl_switch{
                                &.checked::after{
                                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                                }
                            }
                        }
                    }
                }
            }
            .room-light_right{

                .right_box1{
                    .wrap1{
                        .echarts_box .electricity_consumption_echarts .electricity_consumption_echarts_tooltip .p1 i{
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%) !important;
                        }
                        .wrap1_top_2{
                            .box1{
                                .p2{
                                    color: #513C93;
                                }
                            }
                        }

                    }
                }
                .right_box2{
                    .p1{
                        .pl_switch{
                            &.checked::after{
                                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                            }
                        }
                    }
                    .slider1{
                        .el-slider__bar,.el-slider__button{
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                    }
                    .dataColor_1_box_box{
                        .cirdadian_slider{
                            .el-slider.slider_2{
                                .el-slider__bar,.el-slider__button{
                                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                                }
                            }
                        }
                        .btn_box{
                            .btn{
                                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                            }
                        }
                        .brightness .dataColor_1_box .btn{
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                    }
                }
                .right_box2_2{
                    .li1{
                        .li_r{
                            color: #513C93;
                            font-weight: 600;
                        }
                    }
                    .li3{
                        .li_r{
                            color: #513C93;
                            font-weight: 600;
                        }
                    }
                }
                .right_box2_3{
                    .li1{
                        .pl_switch{
                            &.checked::after{
                                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                            }
                        }
                    }
                    .li2{
                        .li_r{
                            color: #513C93;
                            font-weight: 600;
                        }
                    }
                }
            }
            .room-light_bottom{
                .li{
                    &.select{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .pl_switch.checked::after{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .li_box .wake_up_time .time_warp .scrollbar_style::-webkit-scrollbar-thumb{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .li_box .bed_time .time_warp .scrollbar_style::-webkit-scrollbar-thumb{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                }
                .li.select .flex{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
            }
        }
        .light_icon_box{
            p{
                position: absolute;
                left: 0;right: 0;bottom: 1rem;
                color: #fff;
                text-align: center;
            }
            font-family: AlibabaPuHuiTiB;
        }
        .light_img_box{
            width: 9rem;height: 9rem;
            position: absolute;
            top: 17.5rem;left: 50%;margin-left: -5.5rem;
            img{
                width: 100%;height: 100%;
            }
        }
        .cirLight_img_box{
            width: 9rem;height: 9rem;
            position: absolute;
            top: 13rem;left: 50%;margin-left: 20.5rem;
            img{
                width: 100%;height: 100%;
            }
        }
        .sensor_img_box{
            width: 9rem;height: 9rem;
            position: absolute;
            top: 18.5rem;left: 50%;margin-left: -18.5rem;
            img{
                width: 100%;height: 100%;
            }
        }
        .airPurifiers_img_box{
            width: 9rem;height: 9rem;
            position: absolute;
            top: 28.5rem;left: 50%;margin-left: 20.5rem;
            img{
                width: 100%;height: 100%;
            }
        }
        .time_box{
            position: absolute;
            top: 6rem;
            left: 32rem;
            display: flex;
            .box{
                font-family: AlibabaPuHuiTiR;
                font-size: 1rem;
                color: #fff;
                display: flex;
                align-items: center;
                img{
                    margin-right: 0.6rem; 
                    height: 1.2rem;
                }
                .span1{

                }
                .span2{
                    margin-right: 3rem;
                }
            }
        }
        .room-light_top{
            display: flex;
            align-items: center;
            height: 2.67rem;
            background: #FFFFFF;
            box-shadow: 0 2px 6px 0 rgba(0,0,0,0.05);
            .span1{
                font-family: AlibabaPuHuiTiR;
                font-size: 1rem;
                color: #333333;
            }
            .span2{
                font-family: AlibabaPuHuiTiR;
                font-size: 1rem;
                color: #A3AFBB;
            }
            .box{
                margin-left: 1rem;
            }
            .btn{
                line-height: 2.67rem;
                cursor: pointer;
                .iconfont{
                    margin-right: 0.5rem;
                    font-size: 0.8rem;
                }
            }
        }
        .room-light_left{
            position: absolute;
            left: 0;
            width: 50%;
            height: calc(100% - 2.67rem;);
            .flex_ul1{
                position: relative;
                margin: 2.83rem 0 0 2.5rem;
                width: 24rem;height: 22.92rem;
                display: flex;
                flex-wrap: wrap;
                align-content: flex-start;
                background: rgba(255,255,255,1);
                box-shadow: 0 2px 1rem 0 rgba(102,102,102,0.07);
                border-radius: 0.9rem;
                z-index: 1;
                .flex_li{
                    width: 50%;height: 50%;
                    text-align: center;
                    position: relative;
                    &:nth-child(1){
                        border-right: 1px solid #EBEFF2;
                        border-bottom: 1px solid #EBEFF2;
                    }
                    &:nth-child(2){
                        border-bottom: 1px solid #EBEFF2;
                    }
                    &:nth-child(3){
                        border-right: 1px solid #EBEFF2;
                    }
                    img{
                        width: 5rem;height: 5rem;
                        margin: 2.92rem auto 0.58rem;
                    }
                    p{
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        color: #333333;
                        letter-spacing: 0;
                        margin-top: -1.5rem;
                    }
                    cursor: pointer;
                    &.select{
                        p{
                            font-family: AlibabaPuHuiTiB;
                        }
                        .bg1{
                            position: absolute;
                            width: 8.57rem;height: 8.57rem;
                            top: 2.17rem;left: 50%;margin-left: -4.28rem;
                            background-color:rgba(255,219,39,0.03);
                            border-radius: 50%;
                        }
                        .bg2{
                            position: absolute;
                            width: 3.92rem;height: 3.92rem;
                            top: 4.57rem;left: 50%;margin-left: -1.96rem;
                            background-color:rgba(255,219,39,0.1);
                            border-radius: 50%;
                        }
                    }
                }
                // .flex_li1{
                //     img{
                //         width: 3.83rem;height: 3.83rem;
                //         margin: 2.92rem auto 0.58rem;
                //     }
                // }
                // .flex_li2{
                //     img{
                //         margin: 4.95rem 0 1.5rem;
                //         width: 4rem;height: 1rem;
                //     }
                // }
                .flex_li3{
                    // img{
                    //     margin: 3.5rem 0 0.83rem;
                    //     height: 2.67rem;
                    // }
                    &.select{
                        .bg1{
                            position: absolute;
                            width: 8.57rem;height: 8.57rem;
                            top: 2.17rem;left: 50%;margin-left: -4.28rem;
                            background-color:rgba(5,207,171,0.03);
                            border-radius: 50%;
                        }
                        .bg2{
                            position: absolute;
                            width: 3.92rem;height: 3.92rem;
                            top: 4.57rem;left: 50%;margin-left: -1.96rem;
                            background-color:rgba(5,207,171,0.1);
                            border-radius: 50%;
                        }
                    }
                }
            }
            .flex_ul2{
                position: relative;
                margin-left: 3.5rem;
                width: 22rem;
                height: calc(100% - 28.4rem);
                // padding: 1.08rem 0 0;
                background: rgba(255,255,255,0.9);
                box-shadow: 0 0.17rem 1rem 0 rgba(102,102,102,0.07);
                border-radius: 0 0 10px 10px;
                padding: 1rem 0;
                // padding-right: 8px;
                .flex_ul{
                    // margin: 1.08rem 0 1rem;
                    height: 100%;
                    .flex_li_box{
                        width: calc(100% - 3rem);
                        margin: 0 1.5rem;
                        display: flex;
                        flex-wrap: wrap;
                        align-content: flex-start;
                        &.select{
                            background: #EBEFF2;
                            border-radius: 5px;
                        }
                    }
                }
                .flex_li{
                    position: relative;
                    width: calc(50% - 0.5rem);
                    height: 10.08rem;
                    text-align:center;
                    cursor: pointer;
                    margin-bottom: 1rem;
                    &:nth-child(2n){
                        margin-left: 1rem;
                    }
                    &:hover{
                        background: rgba(255,255,255,0.5);
                        border-radius: 5px;
                    }
                    &.select{
                        background: #FFFFFF;
                        border-radius: 5px;
                        .bg{
                            border: 0.2rem solid #05CFAB;
                        }
                        &.offline{
                            .bg{
                                border: 0.2rem solid red;
                            }
                        }
                    }
                    .img_box{
                        margin: 0.92rem auto 0;
                        position: relative;
                        width: 5.83rem;height: 5.83rem;
                        .bg{
                            width: 5.83rem;height: 5.83rem;
                            border-radius: 50%;
                            overflow: hidden;
                            background-position: center;
                            background-size: 100% 100%;
                            background-image: url('../img/login_bg_11.jpg');
                            img{
                                width: 100%;
                                height: 100%;
                            }
                        }
                        .pl_switch{
                            position: absolute;
                            right: 0;
                            bottom: 0;
                            display: inline-block;
                            width: 2.33rem;
                            height: 1.3rem;
                            background-color:#EBEFF2;
                            border-radius: 1.08rem;
                            cursor: pointer;
                            .el-loading-mask{
                                background-color:rgba(255,255,255,0.4);
                                .el-loading-spinner{
                                    margin-top: -0.65rem
                                }
                                .circular{
                                    width: 1.3rem;height: 1.3rem;
                                }
                            }
                            &::after{
                                position: absolute;
                                left: 0.2rem;top: 0.2rem;
                                width: 0.93rem;height: 0.93rem;border-radius: 50%;
                                content: '';
                                background-color:#A3AFBB;
                                transition: all 0.5s;
                            }
                            &.checked{
                                background-color:#E1F1E7;
                               &::after{
                                    left: 1.15rem;
                                    background-color:#05CFAB;
                               } 
                            }
                        }
                    }
                    .name{
                        margin-top: 0.83rem;
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        color: #333333;
                    }
                    .spot{
                        position: absolute;
                        top: 0.8rem;right:0.8rem;
                        width: 0.4rem;height: 0.4rem;
                        border-radius:50%;
                        background:#a3afbb;
                        &.select{
                            background:#FF7F50;
                        }
                    }
                    .status{
                        position: absolute;
                        bottom: 3.5rem;right:1rem;
                        height: 1.2rem;line-height: 1.2rem;
                        font-size: 1rem;
                        padding: 0 0.5rem;
                        border-radius: 0.5rem;
                        background:red;
                        color:#fff;
                        &.online{
                            color:#fff;
                            background:#05cfab;
                        }
                    }
                }
                .btn{
                    position: absolute;
                    left: 50%;
                    margin-left: -1.875rem;
                    bottom: -1.875rem;
                    width: 3.75rem;height: 3.75rem;line-height: 3.75rem;
                    border-radius: 50%;
                    background: #C6CDD5;
                    font-family: AlibabaPuHuiTiR;
                    font-size: 1rem;
                    color: #FFFFFF;
                    text-align: center;
                    cursor: pointer;
                    &.select{
                        background-color:#05CFAB;
                    }
                }
            }
        }
        .room-light_right{
            position: absolute;
            right: 0;
            width: 50%;
            height: calc(100% - 2.67rem);
            display: flex;
            flex-direction: column; /*垂直排列*/
            align-items: flex-end; /*右对齐*/
            padding: 2.59rem 2.5rem 0 0;
            
            .el-slider__runway{
                height: 1.2rem;
                margin: 0.5rem 0;
                background-color: rgba(246, 248, 247, 1);
                border-radius: 0.83rem;
                .el-slider__bar{
                    margin: 0.35rem;
                    height: 0.5rem;
                }
                .el-slider__button-wrapper{
                    width:1.2rem;height: 1.2rem;
                    top: -0.15rem;
                }
                .el-slider__button{
                    width:1.2rem;height: 1.2rem;
                }
            }
            .right_box1{
                width: 26rem;
                // height: 19.5rem;
                .right_box1_top{
                    height: 2.25rem;line-height: 2.25rem;
                    // padding-left: 1.33rem;
                    display: flex;
                    text-align:center;
                    .box1{
                        width: 10rem;
                        height: 100%;
                        position: relative;
                        cursor: pointer;
                        background: rgba(255,255,255,0.5);
                        border-radius: 0.83rem 0 0 0;
                        .bg{
                            position: absolute;
                            width: 100%;height: 100%;
                            top: 0;left: 1.3rem;
                            transform: skew(30deg);
                        }
                        .text{
                            height: 2.3rem;
                            left: 0rem;
                            position: relative;
                            z-index: 1;
                            background-color: rgba(0,0,0,0);
                            border-radius: 0.83rem 0 0 0;
                        }
                        &.select{
                            width: 13rem;
                            background: rgba(255,255,255,0.5);
                            .bg{
                                background: rgba(255,255,255,1);
                            }
                            .text{
                                background-color: rgba(255,255,255,255);
                            }
                        }
                    }
                    .box2{
                        margin-left:1rem;
                        width: 9rem;
                        height: 100%;
                        position: relative;
                        cursor: pointer;
                        z-index: 1;
                        .bg{
                            position: absolute;
                            width: 100%;height: 100%;
                            top: 0;left: -1rem;
                            background: rgba(255,255,255,0.5);
                            transform: skew(30deg);
                        }
                        .text{
                            position: relative;
                            z-index: 1;
                            background-color: rgba(0,0,0,0);
                        }
                        &.select{
                            margin-left:0rem;
                            width: 11rem;
                            background: rgba(255,255,255,1);
                            // border-radius: 0.83rem 0 0 0;
                            .bg{
                                background: rgba(255,255,255,1);
                                left: 1rem; 
                            }
                        }
                    }
                }
                .wrap1{
                    background: #FFFFFF;
                    box-shadow: 0 2px 1rem 0 rgba(102,102,102,0.07);
                    border-radius: 0 10px 10px 10px;
                    padding: 1.08rem 1.33rem 1rem;
                    // height: 17.2rem;
                    .echarts_box{
                        // height: 11.5rem;
                        background: #F6F8F7;
                        border-radius: 5px;
                        .top{
                            .div1{
                                margin-left: 1.17rem;
                                display: flex;
                                .div1_l{
                                    margin-top: 0.58rem;
                                    font-family: AlibabaPuHuiTiM;
                                    font-size: 4.17rem;line-height: 5.75rem;
                                    color: #333333;
                                    
                                }
                                .div1_r{
                                    margin-left: 0.25rem;
                                    .p1{
                                        margin-top: 2.58rem;
                                        font-family: AlibabaPuHuiTiM;
                                        font-size: 1rem;line-height: 1.42rem;
                                        color: #333333;
                                    }
                                    .p1{
                                        font-family: AlibabaPuHuiTiR;
                                        font-size: 1rem;
                                        color: #657085;
                                    }
                                }
                            }
                            .div2{
                                margin: 0.67rem 1.33rem 0 1.67rem;
                                border: 0.1rem solid #EEF1EF;
                            }
                        }
                        .echarts_top{
                            display: flex;
                            justify-content: space-between;
                            font-family: AlibabaPuHuiTiB;
                            font-size: 1rem;
                            color: #657085;
                            padding: 0.67rem 0.92rem 1rem;
                            .el-dropdown{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                cursor: pointer;
                            }
                        }
                        .electricity_consumption_echarts{
                            width: 100%;
                            height:12.2rem;
                            &.deviceType3{
                                height: 13.2rem;
                            }
                            .electricity_consumption_echarts_tooltip{
                                background-color:#fff;
                                padding: 0.3rem 1rem 0.67rem 0;
                                .p1{
                                    display: flex;
                                    align-items: center;
                                    font-size:1rem;
                                    font-family:AlibabaPuHuiTiM;
                                    color:rgba(51,51,51,1);
                                    i{
                                        background: #05CFAB !important;
                                        margin-left: 0.92rem;
                                        margin-right: 0.5rem;
                                        display: inline-block;
                                        width: 0.25rem;height: 0.25rem;
                                        border-radius: 50%;
                                    }
                                    .span1{
                                        margin-right: 0.3rem;
                                    }
                                }
                                .p2{
                                    font-size:1rem;
                                    font-family:AlibabaPuHuiTiM;
                                    color:rgba(163,175,187,1);
                                    padding-left: 1.75rem;
                                }
                            }
                        }
                    }
                    .wrap1_top_2{
                        height: 21.5rem;
                        padding: 0.92rem 1.17rem 0;
                        background: #F6F8F7;
                        border-radius: 0.5rem;
                        .title{
                            font-family: AlibabaPuHuiTiB;
                            font-size: 1rem;
                            color: #657085;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            i{
                                cursor: pointer;
                                .el-loading-spinner{
                                    margin-top: -0.5rem;
                                    .circular{
                                        width: 1rem; height: 1rem;
                                    }
                                }
                            }
                        }
                        .box1{
                            margin-top: 1.33rem;
                            background: #EEF1EF;
                            border-radius: 0.8rem;
                            height: 4.08rem;
                            padding: 0.75rem 0 0 1.08rem;
                            position: relative;
                            .p1{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                            }
                            .p2{
                                font-family: AlibabaPuHuiTiM;
                                font-size: 1rem;
                                color: #05CFAB;
                            }
                            .img_box{
                                width: 3rem;height: 2.6rem;
                                position: absolute;
                                right: 0;bottom: 0;
                                border-radius: 0 0 0.8rem  0;
                                overflow: hidden;
                                img{
                                    width: 100%;height: 100%;
                                }
                            }
                        }
                        .flex_ul{
                            display: flex;
                            flex-wrap: wrap;
                            align-content: flex-start;
                            .flex_li{
                                margin-top: 1.33rem;
                                width: 33.33%;
                                .p1{
                                    font-family: AlibabaPuHuiTiR;
                                    font-size: 1rem;
                                    color: #657085;
                                }
                                .p2{
                                    font-family: AlibabaPuHuiTiM;
                                    font-size: 1rem;
                                    color: #333333;
                                }
                            }
                        }
                    }
                    .bottom{
                        cursor: pointer;
                        margin-top: 0.83rem;
                        height: 2.83rem;line-height: 2.83rem;
                        background: rgba(255,12,77,0.1);
                        border-radius: 5px;
                        display: flex;
                        justify-content: space-between;
                        padding: 0 1rem;
                        .img_box{
                            img{
                                margin-right: 0.92rem;
                                height: 1.04rem;
                            }
                            font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .text_box{
                            font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #FF0C4D;
                        }
                    }
                }
                .wrap2{
                    position: relative;
                    background: #FFFFFF;
                    box-shadow: 0 2px 1rem 0 rgba(102,102,102,0.07);
                    border-radius: 0 10px 10px 10px;
                    height: 51.5rem;
                    padding-top: 2.92rem;
                    .img_box{
                        width: 9.5rem;height: 9.5rem;
                        margin:0rem auto 2.67rem;
                        img{
                            width: 100%;height: 100%;
                        }
                    }
                    .div{
                        background: #F6F8F7;
                        height: 3.5rem;line-height:3.5rem;
                        border-radius: 2px;
                        margin: 0 1.5rem 0.83rem;
                        padding: 0 1rem;
                        display: flex;
                        justify-content: space-between;
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        .span1{
                            color: #333333;
                        }
                        .span2{
                            color: #657085;
                            max-width: calc(100% - 6rem);
                            display: inline-block;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            vertical-align: middle;
                        }
                        .el-dropdown{
                            max-width:calc(100% - 11rem);
                            cursor: pointer;
                            .el-dropdown-link{
                                display: inline-block;
                                display: flex;
                                align-items: center;
                                height:100%;
                                span{
                                    overflow: hidden;
                                    text-overflow:ellipsis;
                                    white-space: nowrap;
                                    display: inline-block;

                                }
                            }
                        }
                    }
                    .btn_box{
                        position: absolute;
                        bottom: 0;
                        left: 0;right: 0;
                        display: flex;
                        align-items: center;
                        background: #EAEFEE;
                        border-radius: 0 0 10px 10px;
                        height: 3.33rem;line-height: 3.33rem;
                        text-align:center;
                        .l{
                            width: 0.1rem;height: 0.83rem;
                            background-color: #BFCAC8;
                        }
                        .btn{
                            flex: 1;
                            font-family: AlibabaPuHuiTiM;
                            font-size: 1rem;
                            color: #3A7337;
                            cursor: pointer;
                        }
                    }
                }
            }
            .right_box2{
                width: 26rem;
                height: calc(100% - 23rem);
                margin-top: 0.83rem;
                background: #FFFFFF;
                box-shadow: 0 2px 1rem 0 rgba(102,102,102,0.07);
                border-radius: 10px;
                .scrollbar_style{
                    height: 100%;
                    padding: 1.17rem 1.42rem 0;
                    position: relative;
                }
                .RGBW_box{
                    margin-top: 1rem;
                    display: flex;
                    .btn{
                        margin-right: 1rem;
                        height:2.5rem;line-height:2.5rem;
                        // padding: 0 1rem;
                        background:rgba(246,248,247,1);
                        border-radius:1rem;
                        cursor: pointer;
                        flex: 1;
                        text-align: center;

                        font-size:1rem;
                        font-family:AlibabaPuHuiTiR;
                        color:rgba(101,112,133,1);
                        &.select{
                            background:#05CFAB;
                            color: #fff;
                        }
                    }
                }
                .p1{
                    font-family: AlibabaPuHuiTiB;
                    font-size: 1rem;
                    color: #000;
                    display: flex;
                    justify-content: space-between;
                    .pl_switch{
                        position: relative;
                        display: inline-block;
                        width: 2.33rem;
                        height: 1.3rem;
                        background-color:#EBEFF2;
                        border-radius: 1.08rem;
                        cursor: pointer;
                        .el-loading-mask{
                            background-color:rgba(255,255,255,0.4);
                            .el-loading-spinner{
                                margin-top: -0.65rem
                            }
                            .circular{
                                width: 1.3rem;height: 1.3rem;
                            }
                        }
                        &::after{
                            position: absolute;
                            left: 0.2rem;top: 0.2rem;
                            width: 0.93rem;height: 0.93rem;border-radius: 50%;
                            content: '';
                            background-color:#A3AFBB;
                            transition: all 0.5s;
                        }
                        &.checked{
                            background-color:#E1F1E7;
                           &::after{
                                left: 1.15rem;
                                background-color:#05CFAB;
                           } 
                        }
                        
                    }
                }
                .p2{
                    font-family: AlibabaPuHuiTiR;
                    font-size: 1rem;
                    color: #333333;
                    &.p21{
                        margin: 1.17rem 0 0; 
                    }
                    &.p22{
                        margin: 2rem 0 0; 
                    }
                    &.p23{
                        margin: 2rem 0 0; 
                    }
                }
                .p3{
                    line-height: 2.5rem;
                    font-family: AlibabaPuHuiTiB;
                    font-size: 1.67rem;
                    color: #333333;
                    .el-input-number{
                        display: none;
                        width: 5rem;
                        .text{
                            &.loading{
                                display: none;
                            }
                        }
                        .el-input{
                            height: 2.3rem;line-height: 2.3rem;
                            .el-input__inner{
                                height: 2.3rem;line-height: 2.3rem;
                                padding: 0;text-align: center;
                                font-family: AlibabaPuHuiTiB;
                                font-size: 1.67rem;
                                color: #333333;
                                border-width: 0.1rem;
                            }
                        } 
                    }
                    &:hover{
                        .el-input-number{
                            display: inline-block;
                        }
                        .text{
                            display: none;
                        }
                        .el-input-number{
                            display: inline-block;
                        }
                    }
                }
                .slider1{
                    .el-slider__bar{
                        background-color:#05CFAB;
                    }
                    .el-slider__button{
                        border: 0.25rem solid #FFFFFF;
                        background-color: #05CFAB;
                    }
                }
                .slider2{
                    .el-slider__bar{
                        background-color:#FFBE00;
                    }
                    .el-slider__button{
                        border: 0.25rem solid #FFFFFF;
                        background-color: #FFBE00;
                    }
                }
                .color_picker{
                    .el-slider__runway{
                        height: 1rem;
                        margin: 0.5rem 0;
                        background-color: rgba(246, 248, 247, 1);
                        border-radius: 0.83rem;
                        .el-slider__bar{
                            margin: 0.35rem;
                            height: 0.5rem;
                        }
                        .el-slider__button-wrapper{
                            width:1rem;height: 1rem;
                            top: -0.3rem;
                        }
                        .el-slider__button{
                            width:1rem;height: 1rem;
                            border: 0.2rem solid #FFFFFF;
                            background-color: initial;
                        }
                    }
                }
                .dataColor_1_box_box{
                    position:relative;
                    margin-top:1.6rem;
                    input[type=number] {
                        -moz-appearance:textfield;
                    }
                    input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button {
                        -webkit-appearance: none;
                        margin: 0;
                    }

                    .btn_box{
                        width: 100%;
                        margin-top: 2rem;
                        .btn{
                            width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                            margin: 0 auto;
                            background: #05CFAB;
                            border-radius: 0.2rem;
                            text-align:center;
                            cursor: pointer;
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #FFFFFF;
                        }
                    }
                    .cirdadian_slider{
                        display: flex;
                        align-items: center;
                        .hotel_forecast{
                            cursor: pointer;
                            position: relative;
                            .el-loading-spinner{
                                top: 0;margin-top: 0;
                                height: 100%;
                                .circular{
                                    height: 100%;
                                    width: 50%;
                                }
                            }
                        }
                        img{
                            height:2.2rem;
                        }
                        .el-slider{
                            margin-left: 1rem;
                            width: calc(100% - 3rem);
                            .el-slider__runway{
                                background: #eeeeee;
                            }
                            &.slider_0{
                                .el-slider__bar{
                                    background-color:#eeeeee;
                                }
                                .el-slider__button{
                                    border: 0.25rem solid #FFFFFF;
                                    background-color: #878787;
                                }
                                
                            }
                            &.slider_2{
                                .el-slider__bar{
                                    background-color:#FFBE00;
                                }
                                .el-slider__button{
                                    border: 0.25rem solid #FFFFFF;
                                    background-color: #FFBE00;
                                }
                            }
                        }
                    }
                    .span{
                        text-align: center;
                        font-size:0.8rem;
                        font-family:AlibabaPuHuiTiR;
                        color:rgba(101,112,133,1);
                    }
                    .p1{
                        margin-top: 1rem;
                        align-items: center;
                        .btn{
                            display: inline-block;
                            padding: 0.2rem 2rem;
                            background: #898989;
                            border-radius: 2rem;
                            color:#fff;
                            cursor: pointer;
                            &.run{
                                color:#fff;
                                background:#05CFAB;
                            }
                        }
                    }
                    .input_box{
                        display: flex;
                        align-items: center;

                        .span_input{
                            margin-right: auto;
                        }
                        .el-input{
                            width: 2rem;
                            &.color_input{
                                width: 1.2rem;
                                margin-right: 0.1rem;
                                .el-input__inner{
                                    height:1.5rem;line-height: 1.5rem;
                                }
                                &:first-child{
                                    margin-left: auto;
                                }
                            }
                            &.time1{
                                margin-left: auto;
                            }
                            &.time2{
                                margin-right: auto;
                            }
                            &.time3{
                                margin-left: auto;
                            }
                            &.time4{
                                margin-right: auto;
                            }
                        }
                        .el-input__inner{
                            height:2rem;line-height: 2rem;
                            background:rgba(246,248,247,1);
                            border-radius:0.17rem;
                            text-align: center;
                            padding: 0;

                            font-size:1rem;
                            font-family:AlibabaPuHuiTiR;
                            color:rgba(51,51,51,1);
                        }
                    }
                    .sunrise_sunset{
                        margin-top: 0.8rem;
                        display: flex;
                        .sunrise{
                            flex: 1;
                        }
                        .sunset{
                            flex: 1;
                        }
                        .gauge_box{
                            // width: 8rem;
                            // height: 4rem;
                            .gauge{
                                width: 7rem;
                                height: 3.5rem;
                                background-image: url('../img/room/gauge_0.png');
                                background-position: center;
                                background-size: 100% 100%;
                                position: relative;
                                overflow: hidden;
                                .after{
                                    position: absolute;
                                    left:50%;
                                    bottom: 0;
                                    margin-left: -1px;
                                    width: 2px;
                                    height: 98%;
                                    background:#666;
                                    // transform: rotate(-72deg);
                                    transform-origin: 0% 100%;
                                }
                                &::before{
                                    position: absolute;
                                    left: 16%;
                                    top: 32%;
                                    width: 72%;
                                    height: 144%;
                                    content: "";
                                    background: #fff;
                                    border-radius: 50%;
                                    background: #fff;
                                    z-index: 1;
                                }
                                &.gauge_1{
                                    background-image: url('../img/room/gauge_1.png');
                                }
                                .text{
                                    position: relative;z-index: 1;
                                    text-align: center;
                                    font-size:0.8rem;
                                    font-family:AlibabaPuHuiTiR;
                                    color:rgba(101,112,133,1);
                                    &.text1{
                                        position: absolute;
                                        width: 100%;
                                        bottom: 1rem;
                                    }
                                    &.text2{
                                        position: absolute;
                                        width: 100%;
                                        bottom: 0rem;
                                    }
                                }
                            }
                            .input_box{
                                margin-top: 0.5rem;
                            }
                        }
                    }
                    .brightness{
                        margin-top: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .dataColor_1_box .btn{
                            background: #05CFAB;
                        }
                    }
                    .flex{
                        display: flex;
                    }
                    .title{
                        font-size: 1rem;
                        font-family: AlibabaPuHuiTiR;
                        color: #657085;
                    }
                    .dataColor_1_box{
                        margin-left: 1rem;
                        width: 9rem;
                        // flex: 1;
                        display: flex;
                        align-items:center;
                        .el-slider{
                            width: calc(100% - 5.2rem);
                            margin: 0 0.6rem;
                        }
                        .btn{
                            width:1.5rem;
                            height:1.5rem;line-height: 1.5rem;
                            background:rgba(255,190,0,1);
                            border-radius:0.17rem;

                            text-align: center;
                            font-size: 0.6rem;
                            color:rgba(255,255,255,1);
                            cursor: pointer;
                            &.btn1{
                                margin-right: 0.6rem;
                            }
                            &.btn2{
                                margin-left: 0.6rem;
                            }
                        }
                    }
                    .manual_control{
                        margin-top: 1rem;
                        &.activated{
                            .brightness .dataColor_1_box .btn,.el-slider .el-slider__button,.dataColor_1_box .btn,.dataColor_2_box .btn,.el-slider .el-slider__bar{
                                background: #878787;
                            }

                        }
                        .colorTemp{
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                        }
                        .flex{
                            display: flex;
                        }
                        .title{
                            font-size: 1rem;
                            font-family: AlibabaPuHuiTiR;
                            color: #657085;
                        }
                        .dataColor_1_box{
                            margin-left: 1rem;
                            width: 9rem;
                            // flex: 1;
                            display: flex;
                            align-items:center;
                            .el-slider{
                                width: calc(100% - 5.2rem);
                                margin: 0 0.6rem;
                            }
                            .btn{
                                width:1.5rem;
                                height:1.5rem;line-height: 1.5rem;
                                background:rgba(255,190,0,1);
                                border-radius:0.17rem;

                                text-align: center;
                                font-size: 0.6rem;
                                color:rgba(255,255,255,1);
                                cursor: pointer;
                                &.btn1{
                                    margin-right: 0.6rem;
                                }
                                &.btn2{
                                    margin-left: 0.6rem;
                                }
                            }
                        }
                    }
                    .simulation_test{
                        margin-top: 1rem;
                        .simulation{
                            width: calc(100% - 2rem);
                            margin: 0 auto;
                            height: 1rem;
                            background-image: url('../img/room/simulation_0.png');
                            background-position: center;
                            background-size: 100% 100%;
                            position: relative;
                            &.run{
                                background-image: url('../img/room/simulation_1.png');
                            }
                            .line{
                                position: absolute;
                                top: 0.2rem;
                                width: 2px;
                                height: 0.6rem;
                                background: #666;
                            }
                        }
                        .test_box{
                            width: calc(100% - 2rem);
                            margin: 0 auto;
                            margin-top: 0.5rem;
                            display:flex;
                            justify-content: space-between;
                            align-items: center;

                            font-size: 1rem;
                            font-family: AlibabaPuHuiTiR;
                            color: #657085;
                        }
                    }
                    .bottom_box{
                        margin-top: 1rem;
                        font-size: 1rem;
                        font-family: AlibabaPuHuiTiR;
                        color: #657085;
                        margin-bottom: 1rem;
                        .input_box{
                            .title{
                                width: 6.5rem;
                            }
                            margin-left: 5rem;
                            flex{
                                display: flex;
                            }
                        }
                    }
                    .sunrise_sunset_type{
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        margin-bottom: 1rem;
                        .btn{
                            margin-top: 0.8rem;
                            height:2.5rem;line-height: 2.5rem;
                            background:rgba(246,248,247,1);
                            border-radius:0.17rem;
                            text-align: center;
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiR;
                            color:rgba(101,112,133,1);
                            cursor: pointer;
                            &.select{
                                color:rgba(255,255,255,1);
                                background:rgba(5,207,171,1);
                            }
                        }
                        .btn1{
                            width: 100%;
                        }
                        .btn2,.btn3,.btn4,.btn5{
                            width: calc(50% - 0.3rem);
                        }
                        .btn2,.btn4{
                            margin-right: 0.6rem;
                        }
                    }
                }
                .img_box{
                    position: absolute;
                    width: calc(100% - 4rem);
                    bottom: 3.5rem;left: 2rem;
                    img{
                        width: 100%;
                    }
                }
            }
            .right_box2_2{
                width: 26rem;height: calc(100% - 29.5rem);
                margin-top: 0.83rem;
                background: #FFFFFF;
                box-shadow: 0 2px 1rem 0 rgba(102,102,102,0.07);
                border-radius: 1rem;
                .p1{
                    margin: 1.17rem 1.5rem;
                    font-family: AlibabaPuHuiTiB;
                    font-size: 1rem;
                    color: #657085;
                }
                .scrollbar_style{
                    padding: 0rem 1.42rem 0;
                    height:  calc(100% - 4rem);
                }
                .li{
                    margin: 0 1.5rem 0.83rem;
                    padding: 0 1rem;
                    display: flex;
                    justify-content: space-between;
                    height: 3.5rem;line-height: 3.5rem;
                    background: #F6F8F7;
                    border-radius: 0.2rem;
                    .li_l{
                        display: flex;
                        align-items: center;
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        color: #333333;
                    }
                    .li_r{
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        color: #657085;
                        display: flex;
                        align-items: center;
                        .bg{
                            margin-right: 0.42rem;
                            display: inline-block;
                            width: 1.75rem;height: 1rem;
                            background-image:url('../img/battery_bg.png');
                            background-size: 100% 100%;
                            background-position: center;
                            position: relative;
                            .bg_val_box{
                                position: absolute;
                                top: 0.15rem;
                                left: 0;
                                display: inline-block;
                                width: calc(100% - 0.2rem);
                                height: 1rem;
                            }
                            .bg_val{
                                position: absolute;
                                top: 0;
                                left: 0;
                                display: inline-block;
                                height: 0.8rem;
                                background-color:rgba(5, 207, 171, 1);
                            }
                        }

                        .pl_switch{
                            margin-left: 0.5rem;
                            position: relative;
                            display: inline-block;
                            width: 3rem;
                            height: 1.6rem;line-height:1.7rem;
                            background-color:#EBEFF2;
                            border-radius: 1rem;
                            cursor: pointer;
                            padding: 0 0.5rem;
                            color: #333;
                            font-size: 1rem;
                            text-align: right;
                            font-family: AlibabaPuHuiTiR;
                            .el-loading-mask{
                                background-color:rgba(255,255,255,0.4);
                                .el-loading-spinner{
                                    margin-top: -0.65rem
                                }
                                .circular{
                                    width: 1.6rem;height: 1.6rem;
                                }
                            }
                            &::after{
                                position: absolute;
                                left: 0.4rem;top: 0.3rem;
                                width: 1rem;height: 1rem;border-radius: 50%;
                                content: '';
                                background-color:#A3AFBB;
                                transition: all 0.5s;
                            }
                            &.checked{
                                background-color:#E1F1E7;
                                text-align: left;
                                color: #333;
                               &::after{
                                    left: 2.6rem;
                                    background-color:#05CFAB;
                               } 
                            }
                        }
                    }
                }
                .li1{
                    .li_r{
                        color: #05CFAB;
                    }
                }
                .li3{
                    .li_r{
                        color: #05CFAB;
                    }
                }
                .li4{
                    .li_r{
                        color: #FF0C4D;
                    }
                }
            }
            .right_box2_3{
                width: 26rem;height: calc(100% - 25rem);
                margin-top: 0.83rem;
                background: #FFFFFF;
                box-shadow: 0 2px 1rem 0 rgba(102,102,102,0.07);
                border-radius: 1rem;
                .p1{
                    margin: 1.17rem 1.5rem;
                    font-family: AlibabaPuHuiTiB;
                    font-size: 1rem;
                    color: #657085;
                }
                .scrollbar_style{
                    padding: 0rem 1.42rem 0;
                    height:  calc(100% - 4rem);
                }
                .li{
                    margin: 0 1.5rem 0.83rem;
                    padding: 0 1rem;
                    display: flex;
                    justify-content: space-between;
                    height: 3.5rem;line-height: 3.5rem;
                    background: #F6F8F7;
                    border-radius: 0.2rem;
                    .li_l{
                        display: flex;
                        align-items: center;
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        color: #333333;
                    }
                    .li_r{
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        color: #657085;
                        position: relative;
                        .el-dropdown{
                            margin-left: 0.83rem;
                            cursor: pointer;
                            font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #657085;
                            .el-dropdown-selfdefine{
                                display: flex;
                                align-items:center;
                            }
                            .span1{
                                display: inline-block;
                                max-width: 8rem;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                        }
                        .disabled{
                            position: absolute;
                            display: inline-block;
                            width: 100%;
                            height: 100%;
                            top: 0;
                            left: 0;
                            cursor: no-drop;
                        }
                    }
                }
                .li1{
                    .el-dropdown{
                        cursor: pointer;
                        .el-loading-mask{
                            background-color:rgba(255,255,255,0);
                            .el-loading-spinner{
                                margin-top: -1.4rem
                            }
                            .circular{
                                width: 1.3rem;height: 1.3rem;
                            }
                        }
                    }
                    .pl_switch{
                        margin-left: 0.83rem;
                        position: relative;
                        display: inline-block;
                        width: 2.33rem;
                        height: 1.3rem;
                        background-color:#E1F1E7;
                        border-radius: 1.08rem;
                        cursor: pointer;
                        .el-loading-mask{
                            background-color:rgba(255,255,255,0.4);
                            .el-loading-spinner{
                                margin-top: -1.4rem
                            }
                            .circular{
                                width: 1.3rem;height: 1.3rem;
                            }
                        }
                        &::after{
                            position: absolute;
                            left: 0.2rem;top: 0.2rem;
                            width: 0.93rem;height: 0.93rem;border-radius: 50%;
                            content: '';
                            background-color:#a3afbb;
                            transition: all 0.5s;
                        }
                        &.checked{
                            background-color:#E1F1E7;
                           &::after{
                                left: 1.15rem;
                                background-color:#05CFAB;
                           } 
                        }
                    }
                }
                .li2{
                    .li_r{
                        color: #05CFAB;
                    }
                }
                .li3{
                    .li_r{
                        color: #FF0C4D;
                    }
                }
            }
        }
        .room-light_bottom{
            position: absolute;
            width:calc(100% - 55rem);
            // height: 2.75rem;
            left: 26rem;
            // margin-left: -30.63rem;
            bottom: 3.08rem;
            border-radius: 1.38rem;
            .room-light_bottom_flex{
                display: flex;
                align-items: center;
                // width: 78rem;
            }
            // background: rgba(255,255,255,0.8);
            // box-shadow: 0 2px 1rem 0 rgba(102,102,102,0.07);
            .li{
                margin-left: 1rem;
                // flex: 1;
                height: 4rem;line-height: 1.5rem;
                padding: 0 0.6rem;
                cursor: pointer;
                background: #898989;
                border-radius: 1.6rem;
                position: relative;

                display: flex;
                justify-content: space-between;
                align-items: center;

                font-family: AlibabaPuHuiTiR;
                font-size: 1rem;
                color: #FFFFFF;
                .el-loading-mask{
                    background-color:rgba(0,0,0,0.4);
                    border-radius: 1.6rem;
                    .el-loading-spinner{
                        margin-top: -0.65rem
                    }
                    .circular{
                        width: 1.3rem;height: 1.3rem;
                    }
                }
                &.select{
                    background: #05CFAB;
                    .flex{
                        background: #05CFAB;
                    }
                }
                &:last-child{
                    margin-right: auto;
                }
                &:first-child{
                    margin-left: auto;
                }
                &:nth-child(1){
                    width: 11rem;
                }
                &:nth-child(2){
                    width: 13rem;
                }
                &:nth-child(3){
                    width: 13rem;
                }
                &:nth-child(4){
                    width: 14rem;
                }
                &:nth-child(5){
                    padding: 0;
                    width: 15rem;
                }
                .span1{
                    flex:1;
                }
                .pl_switch{
                    margin-left: 0.5rem;
                    position: relative;
                    display: inline-block;
                    width: 2.3rem;
                    height: 1.3rem;line-height:1.2rem;
                    background-color:#EBEFF2;
                    border-radius: 1rem;
                    cursor: pointer;
                    padding: 0 0.2rem;
                    color: #333;
                    font-size: 1rem;
                    text-align: right;
                    font-family: AlibabaPuHuiTiR;
                    .el-loading-mask{
                        background-color:rgba(255,255,255,0.4);
                        .el-loading-spinner{
                            margin-top: -0.65rem
                        }
                        .circular{
                            width: 1.3rem;height: 1.3rem;
                        }
                    }
                    &::after{
                        position: absolute;
                        left: 0.2rem;top: 0.2rem;
                        width: 0.9rem;height: 0.9rem;border-radius: 50%;
                        content: '';
                        background-color:#A3AFBB;
                        transition: all 0.5s;
                    }
                    &.checked{
                        background-color:#E1F1E7;
                        text-align: left;
                        color: #333;
                       &::after{
                            left: 1.4rem;
                            background-color:#05CFAB;
                       } 
                    }
                }
                .flex{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                    height: 4rem;line-height: 1.5rem;
                    padding: 0 0.5rem;
                    cursor: pointer;
                    background: #898989;
                    border-radius: 1.6rem;
                    z-index:1;
                }
                .li_box{
                    position: absolute;
                    width: 100%;
                    height:15rem;
                    bottom: 2rem;left:0;
                    background: rgba(179, 177, 180,0.5);
                    .wake_up_time{
                        display: flex;
                        line-height: 2rem;
                        justify-content:space-between;
                        margin-bottom:1rem;
                        // margin-right: 1rem;
                        .test{
                            line-height:6rem;
                            margin-left:0.3rem;
                        }
                        .time_warp{
                            display: flex;
                            margin-right: 1rem;
                            width: 4.2rem;
                            height: 6rem;
                            &::after{
                                content: "";
                                position: absolute;
                                margin-top: 1.9rem;
                                height: 2.2rem;
                                z-index: 0;
                                left: 0;
                                right: 0;
                                box-sizing: border-box;
                                padding-top: 6px;
                                text-align: left;
                                border-top: 0.1px solid #e4e7ed;
                                border-bottom: 0.1px solid #e4e7ed;
                                margin-right: 1rem;
                                margin-left: 7.4rem;
                            }
                            .scrollbar_style::-webkit-scrollbar{
                                width: 0.5rem;height: 0;
                                border-radius: 0.2rem;
                            }
                            .scrollbar_style::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
                                border-radius: 0.2rem;
                                background: #05CFAB;
                            }
                            .scrollbar_style::-webkit-scrollbar-track {/*滚动条里面轨道*/
                                background: rgba(179, 177, 180,0.5);
                            }
                            .time1_box{
                                width: 2.5rem;text-align: center;
                                margin-right: 0px;
                                padding-right: 0.2rem;
                                position: relative;
                                z-index:1;
                                &::after{
                                    content: "";
                                    display: block;
                                    width: 100%;
                                    height: 2rem;
                                }
                                &::before{
                                    content: "";
                                    display: block;
                                    width: 100%;
                                    height: 2rem;
                                }
                                .time1{
                                    height: 2rem;line-height:2rem;
                                    &:hover{
                                        background: rgba(255,255,255,0.2);
                                    }
                                    &.active{
                                        background: initial;
                                    }
                                }
                            }
                            .time2_box{
                                width: 2.5rem;text-align: center;
                                margin-right: 0px;
                                padding-right: 0.2rem;
                                position: relative;
                                z-index:1;
                                &::after{
                                    content: "";
                                    display: block;
                                    width: 100%;
                                    height: 2rem;
                                }
                                &::before{
                                    content: "";
                                    display: block;
                                    width: 100%;
                                    height: 2rem;
                                }
                                .time2{
                                    height: 2rem;line-height:2rem;
                                    &:hover{
                                        background: rgba(255,255,255,0.1);
                                    }
                                    &.active{
                                        background: initial;
                                    }
                                }
                            }
                            .jg{
                                position: relative;
                                z-index:1;
                                >div{
                                    height: 2rem;line-height:2rem;
                                }
                            }
                        }
                    }
                    .bed_time{
                        display: flex;
                        line-height: 2rem;
                        justify-content:space-between;
                        // margin-right: 1rem;
                        .test{
                            line-height:6rem;
                            margin-left:0.3rem;
                        }
                        .time_warp{
                            display: flex;
                            margin-right: 1rem;
                            width: 4.2rem;
                            height: 6rem;
                            &::after{
                                content: "";
                                position: absolute;
                                margin-top: 1.9rem;
                                height: 2.2rem;
                                z-index: 0;
                                left: 0;
                                right: 0;
                                box-sizing: border-box;
                                padding-top: 6px;
                                text-align: left;
                                border-top: 0.1px solid #e4e7ed;
                                border-bottom: 0.1px solid #e4e7ed;
                                margin-right: 1rem;
                                margin-left: 7.4rem;
                            }
                            .scrollbar_style::-webkit-scrollbar{
                                width: 0.5rem;height: 0;
                                border-radius: 0.2rem;
                            }
                            .scrollbar_style::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
                                border-radius: 0.2rem;
                                background: #05CFAB;
                            }
                            .scrollbar_style::-webkit-scrollbar-track {/*滚动条里面轨道*/
                                background: rgba(179, 177, 180,0.5);
                            }
                            .time1_box{
                                width: 2.5rem;text-align: center;
                                margin-right: 0px;
                                position: relative;
                                padding-right: 0.2rem;
                                z-index:1;
                                &::after{
                                    content: "";
                                    display: block;
                                    width: 100%;
                                    height: 2rem;
                                }
                                &::before{
                                    content: "";
                                    display: block;
                                    width: 100%;
                                    height: 2rem;
                                }
                                .time1{
                                    height: 2rem;line-height:2rem;
                                    &:hover{
                                        background: rgba(255,255,255,0.2);
                                    }
                                    &.active{
                                        background: initial;
                                    }
                                }
                            }
                            .time2_box{
                                width: 2.5rem;text-align: center;
                                margin-right: 0px;
                                position: relative;
                                padding-right: 0.2rem;
                                z-index:1;
                                &::after{
                                    content: "";
                                    display: block;
                                    width: 100%;
                                    height: 2rem;
                                }
                                &::before{
                                    content: "";
                                    display: block;
                                    width: 100%;
                                    height: 2rem;
                                }
                                .time2{
                                    height: 2rem;line-height:2rem;
                                    &:hover{
                                        background: rgba(255,255,255,0.1);
                                    }
                                    &.active{
                                        background: initial;
                                    }
                                }
                            }
                            .jg{
                                position: relative;
                                z-index:1;
                                >div{
                                    height: 2rem;line-height:2rem;
                                }
                            }
                        }
                    }
                }
            }
        }
        .history_warp{
            position: fixed;
            width: 100%;height: 100%;
            left: 0;top: 0;
            z-index: 2000;
            .history_warp_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            .history_box{
                position: absolute;
                width: 80.42rem;height: 100%;min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -80.42rem;
                transition: all 0.5s;
                &.history_show{
                   right: 0rem; 
                }
                .history_top{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .filter_box{
                    height: 5.9rem;
                    padding: 1.63rem 0 1.67rem;
                    padding-left: 2.5rem;
                    .el-select{
                        margin-right: 0.83rem
                    }
                    .el-input__inner,.el-input__icon{
                        height: 2.5rem;line-height: 2.5rem;
                    }
                    .el-input__inner{
                        border-radius: 1.25rem;
                    }
                }
                .echarts_warp{
                    height:calc(100%  - 10rem);
                }
                .echarts_box{
                    height: calc(17rem);
                    margin: 0 1.8rem 1.67rem 2.5rem;
                    background: #F6F8F7;
                    border-radius: 5px;
                    .echarts_top{
                        padding-left: 1.67rem;
                        line-height: 2.5rem;
                        font-family: AlibabaPuHuiTiB;
                        font-size: 1rem;
                        color: #333333;
                    }
                    .history_echarts_tooltip{
                        background-color:#fff;
                        padding: 0.3rem 1rem 0.67rem 0;
                        .p1{
                            display: flex;
                            align-items: center;
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiM;
                            color:rgba(51,51,51,1);
                            i{
                                margin-left: 0.92rem;
                                margin-right: 0.5rem;
                                display: inline-block;
                                width: 0.25rem;height: 0.25rem;
                                border-radius: 50%;
                            }
                            .span1{
                                margin-right: 0.3rem;
                            }
                        }
                        .p2{
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiM;
                            color:rgba(163,175,187,1);
                            padding-left: 1.75rem;
                        }

                    }
                    .history_echarts_box1{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box2{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box3{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box4{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box5{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box6{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box7{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                }
            }
        }
        .lights_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .lights_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .lights_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.lights_tk_show{
                    right: 0rem; 
                }
                .lights_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 1.96rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .sensor_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .sensor_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            .sensor_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.sensor_tk_show{
                    right: 0rem; 
                }
                .sensor_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 1.96rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .purifier_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .purifier_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .purifier_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.purifier_tk_show{
                    right: 0rem; 
                }
                .purifier_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 1.96rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        position: relative;
                        .unit{
                            position: absolute;
                            top: 0;
                            right: 0;
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #657085;
                        }
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input-number{
                            width: calc(100% - 15rem);
                            .el-input{
                                width: 100%;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
    }
</style>
